<template>
  <div style="margin-bottom: 15px">
    <nav-menu></nav-menu>
 
    <div class="w3-row w3-container">
      <div class="w3-block w3-text-theme w3-margin-top">
        <h3><i class="fas fa-chart-line"></i> Aferição do Lucro</h3>
      </div>
    </div>

    <div class="w3-row w3-container" style="margin-bottom: 5px" v-cloak>
      <div class="w3-col l3 s12" v-if="(!afericao_lucro) && (!processando)">
        <button class="w3-button w3-theme w3-block" @click="mostrarModalConfiguracoesIniciais()">
          <i class="fa fa-cog"></i> Filtros iniciais
        </button>
      </div>

      <div class="w3-col l3 s12" v-if="afericao_lucro">
        <button class="w3-button w3-theme w3-block" @click="mostrarModalConfiguracoesContas()">
          <i class="fa fa-cog"></i> Config. contas
        </button>
      </div>

      <div class="w3-col l3 s12"  v-if="(!processando)" v-cloak>
        <button class="w3-button w3-theme w3-block" @click="mostrarModalConfiguracoesFinanceirosReceber()">
          <i class="fa fa-cog"></i> Ocultar cadastros fin. receber
        </button>
      </div>

      <div class="w3-col l3 s12"  v-if="(!processando)" v-cloak>
        <button class="w3-button w3-theme w3-block" @click="mostrarModalConfiguracoesFinanceirosPagar2()">
          <i class="fa fa-cog"></i> Ocultar cadastros fin. pagar
        </button>
      </div>

      <div class="w3-col l3 s12" v-if="afericao_lucro" v-cloak>
        <button class="w3-button w3-theme w3-block" @click="mostrarModalConfiguracoesPlanos()">
          <i class="fa fa-cog"></i> Config. DRE
        </button>
      </div>

      <div class="w3-col l3 s12" v-if="afericao_lucro" v-cloak>
        <button class="w3-button w3-theme w3-block" @click="mostrarModalConfiguracoesFinanceirosPagar()">
          <i class="fa fa-cog"></i> Config contas a pagar
        </button>
      </div>

      <div class="w3-col l3 s12" v-if="afericao_lucro" v-cloak>
        <button class="w3-button w3-theme w3-block" @click="baixarPlanilhaResultado()">
          <i class="fa fa-file-excel"></i> Baixar planilha
        </button>
      </div>

      <div class="w3-col l3 s12" v-if="afericao_lucro" v-cloak>
        <button class="w3-button w3-theme w3-block" @click="perguntarRedefinirFiltrosIniciais()">
          <i class="fas fa-redo-alt"></i> Redefinir filtros iniciais
        </button>
      </div>
    </div>

    <div class="w3-row w3-container">
      <div class="w3-col l12">
        <label>Períodos:</label>
        <ul class="lista-leitura-simples" v-cloak>
          <li><strong>{{configuracoes.periodo.periodo_selecionado_1}}</strong></li>
          <li><strong>e</strong></li>
          <li><strong>{{configuracoes.periodo.periodo_selecionado_2}}</strong></li>
        </ul>
      </div>
    </div>

    <div class="w3-row w3-container w3-margin-bottom">
      <label>Empresas:</label>
      <strong v-if="nenhumaEmpresaSelecionada()" v-cloak>Nenhuma empresa selecionada</strong>
      <strong v-if="todasEmpresasSelecionadas()" v-cloak>Todas as empresas</strong>
      
      <ul class="lista-leitura-simples" v-if="(!todasEmpresasSelecionadas())" v-cloak>
        <li
          :key="getKeyListaEmpresas(empresa.empresa_id)"
          v-show="empresa.selecionada"
          v-for="empresa in configuracoes.empresas"
        >
          <strong>{{empresa.empresa_id}} - {{empresa.nome_resumido}}</strong>
        </li>
      </ul>
    </div>

    <div
      class="w3-row w3-container"
      style="margin-bottom: 5px"
      v-if="(!afericao_lucro) && (!processando)"
      v-cloak
    >
      <div class="w3-col l3 s12">
        <button class="w3-button w3-theme w3-block" @click="buscarDadosAfericaoLucro()">
          <i class="fa fa-play-circle"></i> Processar
        </button>
      </div>
    </div>

    <!-- BALANÇO FINANCEIRO -->
    <div class="w3-container" v-if="mostrar_informacoes && afericao_lucro && getTotaisBalancoAtivo">
      <button class="w3-theme w3-button" @click="ajustarExibicao(true)">+</button>
      <button class="w3-theme w3-button" @click="ajustarExibicao(false)">-</button>    
    </div>

    <div class="w3-container" v-if="mostrar_informacoes && afericao_lucro && getTotaisBalancoAtivo">
      <h4>BALANÇO FINANCEIRO</h4>
    </div>

    <div class="w3-container w3-hide-medium w3-hide-large" v-if="mostrar_informacoes && afericao_lucro">
      <!--------------------------- BALANÇO DO ATIVO --------------------------->

      <div class="w3-row cor-enfase">
        <strong>ATIVO:</strong>
        <strong>{{nPadrao(getTotaisBalancoAtivo.resultado, 2)}} {{nPadraoPercentual(getTotaisBalancoAtivo.percentual, 2)}}</strong>
      </div>

      <div class="w3-row cor-enfase-2">
        <label>{{periodo_exibicao_1}}:</label>
        <strong>{{nPadraoTraco(getTotaisBalancoAtivo.total_periodo_1, 2)}}</strong>
      </div>

      <div class="w3-row cor-enfase-2">
        <label>{{periodo_exibicao_2}}:</label>
        <strong>{{nPadraoTraco(getTotaisBalancoAtivo.total_periodo_2, 2)}}</strong>
      </div>

      <div class="w3-row borda-pontilhada-topo">
        <label>Caixas e bancos</label>
        <strong>{{nPadrao(getTotaisContasCaixasBancos.resultado, 2)}} {{nPadraoPercentual(getTotaisContasCaixasBancos.percentual, 2)}}</strong>
      </div>

      <div class="w3-row">
        <label>{{periodo_exibicao_1}}:</label>
        <strong>{{nPadraoTraco(getTotaisContasCaixasBancos.total_periodo_1, 2)}}</strong>
      </div>

      <div class="w3-row">
        <label>{{periodo_exibicao_2}}:</label>
        <strong>{{nPadraoTraco(getTotaisContasCaixasBancos.total_periodo_2, 2)}}</strong>
      </div>

      <div class="w3-row borda-pontilhada-topo">
        <label>Aplicações</label>
        <strong>
          {{nPadrao(getTotaisContasAplicacoes.resultado, 2)}} 
          {{nPadraoPercentual(getTotaisContasAplicacoes.percentual, 2)}}
        </strong>
      </div>

      <div class="w3-row">
        <label>{{periodo_exibicao_1}}:</label>
        <strong>{{nPadraoTraco(getTotaisContasAplicacoes.total_periodo_1, 2)}}</strong>
      </div>

      <div class="w3-row">
        <label>{{periodo_exibicao_2}}:</label>
        <strong>{{nPadraoTraco(getTotaisContasAplicacoes.total_periodo_2, 2)}}</strong>
      </div>

      <div class="w3-row borda-pontilhada-topo">
        <label>Clientes</label>
        <strong>
          {{nPadrao(afericao_lucro.totais_financeiros_receber.resultado, 2)}} 
          {{nPadraoPercentual(afericao_lucro.totais_financeiros_receber.percentual, 2)}}
        </strong>
      </div>

      <div class="w3-row">
        <label>{{periodo_exibicao_1}}:</label>
        <strong>{{nPadraoTraco(afericao_lucro.totais_financeiros_receber.total_periodo_1, 2)}}</strong>
      </div>

      <div class="w3-row">
        <label>{{periodo_exibicao_2}}:</label>
        <strong>{{nPadraoTraco(afericao_lucro.totais_financeiros_receber.total_periodo_2, 2)}}</strong>
      </div>

      <div class="w3-row borda-pontilhada-topo">
        <label>Estoque disponível</label>
        <strong>
          {{nPadrao(afericao_lucro.totais_inventarios.resultado, 2)}} 
          {{nPadraoPercentual(afericao_lucro.totais_inventarios.percentual, 2)}}
        </strong>
      </div>

      <div class="w3-row">
        <label>{{periodo_exibicao_1}}:</label>
        <strong>{{nPadraoTraco(afericao_lucro.totais_inventarios.total_periodo_1, 2)}}</strong>
      </div>

      <div class="w3-row">
        <label>{{periodo_exibicao_2}}:</label>
        <strong>{{nPadraoTraco(afericao_lucro.totais_inventarios.total_periodo_2, 2)}}</strong>
      </div>

      <div class="w3-row borda-pontilhada-topo">
        <label>Investimentos realizados</label>
        <strong>
          {{nPadrao(getTotaisPlanosAtivoInvestimento.resultado, 2)}} 
          {{nPadraoPercentual(getTotaisPlanosAtivoInvestimento.percentual, 2)}}
        </strong>
      </div>

      <div class="w3-row">
        <label>{{periodo_exibicao_1}}:</label>
        <strong>{{nPadraoTraco(getTotaisPlanosAtivoInvestimento.total_periodo_1, 2)}}</strong>
      </div>

      <div class="w3-row">
        <label>{{periodo_exibicao_2}}:</label>
        <strong>{{nPadraoTraco(getTotaisPlanosAtivoInvestimento.total_periodo_2, 2)}}</strong>
      </div>

      <!--------------------------- BALANÇO DO PASSIVO --------------------------->
      <div class="w3-row cor-enfase">
        <strong>PASSIVO:</strong>
        <strong>
          {{nPadrao(getTotaisBalancoPassivo.resultado, 2)}} 
          {{nPadraoPercentual(getTotaisBalancoPassivo.percentual, 2)}}
        </strong>
      </div>

      <div class="w3-row cor-enfase-2">
        <label>{{periodo_exibicao_1}}:</label>
        <strong>{{nPadraoTraco(getTotaisBalancoPassivo.total_periodo_1, 2)}}</strong>
      </div>

      <div class="w3-row cor-enfase-2">
        <label>{{periodo_exibicao_2}}:</label>
        <strong>{{nPadraoTraco(getTotaisBalancoPassivo.total_periodo_2, 2)}}</strong>
      </div>

      <div class="w3-row borda-pontilhada-topo">
        <label>Operacional</label>
        <strong>
          {{nPadrao(getTotaisPassivoOperacional.resultado, 2)}} 
          {{nPadraoPercentual(getTotaisPassivoOperacional.percentual, 2)}}
        </strong>
      </div>

      <div class="w3-row">
        <label>{{periodo_exibicao_1}}:</label>
        <strong>{{nPadraoTraco(getTotaisPassivoOperacional.total_periodo_1, 2)}}</strong>
      </div>

      <div class="w3-row">
        <label>{{periodo_exibicao_2}}:</label>
        <strong>{{nPadraoTraco(getTotaisPassivoOperacional.total_periodo_2, 2)}}</strong>
      </div>

      <div class="w3-row borda-pontilhada-topo">
        <label>Dívidas com investimentos</label>
        <strong>
          {{nPadrao(getTotaisPlanosPassivoInvestimento.resultado, 2)}} 
          {{nPadraoPercentual(getTotaisPlanosPassivoInvestimento.percentual, 2)}}
        </strong>
      </div>

      <div class="w3-row">
        <label>{{periodo_exibicao_1}}:</label>
        <strong>{{nPadraoTraco(getTotaisPlanosPassivoInvestimento.total_periodo_1, 2)}}</strong>
      </div>

      <div class="w3-row">
        <label>{{periodo_exibicao_2}}:</label>
        <strong>{{nPadraoTraco(getTotaisPlanosPassivoInvestimento.total_periodo_2, 2)}}</strong>
      </div>

      <div class="w3-row cor-enfase">
        <strong>SÓCIOS:</strong>
        <strong>
          {{nPadrao(getTotaisBalancoDistribuicaoLucro.resultado, 2)}} 
          {{nPadraoPercentual(getTotaisBalancoDistribuicaoLucro.percentual, 2)}}
        </strong>
      </div>

      <div class="w3-row cor-enfase-2">
        <label>{{periodo_exibicao_1}}:</label>
        <strong>{{nPadraoTraco(getTotaisBalancoDistribuicaoLucro.total_periodo_1, 2)}}</strong>
      </div>

      <div class="w3-row cor-enfase-2">
        <label>{{periodo_exibicao_2}}:</label>
        <strong>{{nPadraoTraco(getTotaisBalancoDistribuicaoLucro.total_periodo_2, 2)}}</strong>
      </div>

      <div class="w3-row cor-enfase">
        <strong>RESULTADO OPERACIONAL:</strong>
        <strong>
          {{nPadrao(getTotaisBalancoResultado.resultado, 2)}} 
          {{nPadraoPercentual(getTotaisBalancoResultado.percentual, 2)}}
        </strong>
      </div>

      <div class="w3-row cor-enfase-2">
        <label>{{periodo_exibicao_1}}:</label>
        <strong>{{nPadraoTraco(getTotaisBalancoResultado.total_periodo_1, 2)}}</strong>
      </div>

      <div class="w3-row cor-enfase-2">
        <label>{{periodo_exibicao_2}}:</label>
        <strong>{{nPadraoTraco(getTotaisBalancoResultado.total_periodo_2, 2)}}</strong>
      </div>
    </div>

    <div class="w3-row w3-container">
      <div class="w3-col l12 w3-margin-bottom" v-if="processando" style="padding: 0 20%">
        <div class="w3-panel w3-theme">
          <p>
            <i class="fa fa-sync-alt w3-spin"></i> Aguarde, o processamento pode demorar de 1 a 30 minutos
          </p>
        </div>
      </div>
    </div>

    <div
      class="w3-row w3-container w3-hide-small"
      v-if="(
      mostrar_informacoes && 
      afericao_lucro && 
      getTotaisBalancoAtivo && 
      getTotaisBalancoPassivo &&
      getTotaisBalancoDistribuicaoLucro &&
      getTotaisBalancoResultado
    )"
    >
      <div class="w3-col l12">
        <table class="tabela-resultado">
          <thead>
            <tr class="tabela-resultado">
              <th style="text-align: left">&nbsp;</th>
              <th>{{periodo_exibicao_1}}</th>
              <th>{{periodo_exibicao_2}}</th>
              <th class="cor-enfase-2">Resultado</th>
              <th style="text-align: center">A.V.</th>
            </tr>
          </thead>
          
          <tbody>
            <!------------- ATIVO ------------->
            <tr class="linha-enfase-principal">
              <td style="text-align: left">
                <strong>ATIVO</strong>
              </td>
              <td>
                <strong>{{nPadraoTraco(getTotaisBalancoAtivo.total_periodo_1, 2)}}</strong>
              </td>
              <td>
                <strong>{{nPadraoTraco(getTotaisBalancoAtivo.total_periodo_2, 2)}}</strong>
              </td>
              <td>
                <strong>{{nPadraoTraco(getTotaisBalancoAtivo.resultado, 2)}}</strong>
              </td>
              <td style="text-align: center">
                <strong>
                  {{nPadraoTraco(getTotaisBalancoAtivo.percentual, 2)}}
                  <span v-show="nPadrao(getTotaisBalancoAtivo.percentual) != ''">%</span>
                </strong>
              </td>
            </tr>

            <tr class="linha-enfase">
              <td style="text-align: left; cursor: pointer" @click="mostrar_caixas_bancos = !mostrar_caixas_bancos">
                <u><b>+ Caixas e bancos</b></u>
              </td>
              <td>{{nPadraoTraco(getTotaisContasCaixasBancos.total_periodo_1, 2)}}</td>
              <td>{{nPadraoTraco(getTotaisContasCaixasBancos.total_periodo_2, 2)}}</td>
              <td>{{nPadraoTraco(getTotaisContasCaixasBancos.resultado, 2)}}</td>
              <td style="text-align: center">
                {{nPadraoTraco(getTotaisContasCaixasBancos.percentual, 2)}}
                <span v-show="nPadrao(getTotaisContasCaixasBancos.percentual) != ''">%</span>
              </td>
            </tr>

            <tr
              :key="getKeyListaTabelaContaId(conta.conta_id + 'BALANCOCAI')"
              v-for="conta in this.getContasTipoSelecionado('CAI')"
              v-show="mostrar_caixas_bancos"
            >
              <td style="text-align: left">
                {{conta.conta_id}} - {{conta.nome_portador}} ({{conta.tipo_analitico}})
              </td>
              <td>{{nPadraoTraco(conta.total_periodo_1, 2)}}</td>
              <td>{{nPadraoTraco(conta.total_periodo_2, 2)}}</td>
              <td class="cor-enfase-2">{{nPadraoTraco(conta.resultado, 2)}}</td>
              <td style="text-align: center">
                {{nPadraoTraco(conta.percentual, 2)}}
                <span v-show="nPadrao(conta.percentual) != ''">%</span>
              </td>
            </tr>

            <tr class="linha-enfase">
              <td style="text-align: left; cursor: pointer" @click="mostrar_aplicacoes = !mostrar_aplicacoes">
                <u><b>+ Aplicações</b></u>
              </td>
              <td>{{nPadraoTraco(getTotaisContasAplicacoes.total_periodo_1, 2)}}</td>
              <td>{{nPadraoTraco(getTotaisContasAplicacoes.total_periodo_2, 2)}}</td>
              <td>{{nPadraoTraco(getTotaisContasAplicacoes.resultado, 2)}}</td>
              <td style="text-align: center">
                {{nPadraoTraco(getTotaisContasAplicacoes.percentual, 2)}}
                <span v-show="nPadrao(getTotaisContasAplicacoes.percentual) != ''">%</span>
              </td>
            </tr>

            <tr
              :key="getKeyListaTabelaContaId(conta.conta_id + 'BALANCOAPL')"
              v-for="conta in this.getContasTipoSelecionado('APL')"
              v-show="mostrar_aplicacoes"
            >
              <td style="text-align: left">
                {{conta.conta_id}} - {{conta.nome_portador}} ({{conta.tipo_analitico}})
              </td>
              <td>{{nPadraoTraco(conta.total_periodo_1, 2)}}</td>
              <td>{{nPadraoTraco(conta.total_periodo_2, 2)}}</td>
              <td class="cor-enfase-2">{{nPadraoTraco(conta.resultado, 2)}}</td>
              <td style="text-align: center">
                {{nPadraoTraco(conta.percentual, 2)}}
                <span v-show="nPadrao(conta.percentual) != ''">%</span>
              </td>
            </tr>

            <tr class="linha-enfase">
              <td style="text-align: left; cursor: pointer" @click="mostrar_clientes = !mostrar_clientes">
                <u><b>+ Clientes</b></u>
              </td>
              <td>{{nPadraoTraco(afericao_lucro.totais_financeiros_receber.total_periodo_1, 2)}}</td>
              <td>{{nPadraoTraco(afericao_lucro.totais_financeiros_receber.total_periodo_2, 2)}}</td>
              <td>{{nPadraoTraco(afericao_lucro.totais_financeiros_receber.resultado, 2)}}</td>
              <td style="text-align: center">
                {{nPadraoTraco(afericao_lucro.totais_financeiros_receber.percentual, 2)}}
                <span v-show="nPadrao(getTotaisBalancoAtivo.percentual) != ''">%</span>
              </td>
            </tr>

            <tr
              :key="getKeyListaTipoSintFinRecTab(fin.tipo_sintetico + 'BALANCOCLIEN')"
              v-for="fin in afericao_lucro.financeiros_receber"
              v-show="mostrar_clientes"
            >
              <td style="text-align: left">{{fin.tipo_analitico}}</td>
              <td>{{nPadraoTraco(fin.total_periodo_1, 2)}}</td>
              <td>{{nPadraoTraco(fin.total_periodo_2, 2)}}</td>
              <td class="cor-enfase-2">{{nPadraoTraco(fin.resultado, 2)}}</td>
              <td style="text-align: center">
                {{nPadraoTraco(fin.percentual, 2)}}
                <span v-show="nPadrao(fin.percentual) != ''">%</span>
              </td>
            </tr>

            <tr class="linha-enfase">
              <td style="text-align: left; cursor: pointer" @click="mostrar_estoque = !mostrar_estoque">
                <u><b>+ Estoque disponível</b></u>
              </td>
              <td>{{nPadraoTraco(afericao_lucro.totais_inventarios.total_periodo_1, 2)}}</td>
              <td>{{nPadraoTraco(afericao_lucro.totais_inventarios.total_periodo_2, 2)}}</td>
              <td>{{nPadraoTraco(afericao_lucro.totais_inventarios.resultado, 2)}}</td>
              <td style="text-align: center">
                {{nPadraoTraco(afericao_lucro.totais_inventarios.percentual, 2)}}
                <span v-show="nPadrao(afericao_lucro.totais_inventarios.percentual) != ''">%</span>
              </td>
            </tr>

            <tr
              :key="getKeyInventarioTabEmpresa(inventario)"
              v-for="inventario in afericao_lucro.inventarios"
              v-show="mostrar_estoque"
            >
              <td style="text-align: left">
                <span v-if="inventario.empresa_id">
                  <span>{{inventario.empresa_id}} - {{inventario.nome_resumido}}</span>
                </span>
                
                <span v-if="inventario.empresa_transferencia_id">
                  <span>Transferências para {{inventario.empresa_transferencia_id}} - {{inventario.nome_resumido}}</span>
                </span>
              </td>


              <td>{{nPadraoTraco(inventario.total_periodo_1, 2)}}</td>
              <td>{{nPadraoTraco(inventario.total_periodo_2, 2)}}</td>
              <td class="cor-enfase-2">{{nPadraoTraco(inventario.resultado, 2)}}</td>
              <td style="text-align: center">
                {{nPadraoTraco(inventario.percentual, 2)}}
                <span v-show="nPadrao(inventario.percentual) != ''">%</span>
              </td>
            </tr>

            <tr key="TRANSFERENCIASBALANCOINV" v-if="temTransferencia(afericao_lucro.transferencias)" v-show="mostrar_estoque">
              <td style="text-align: left">Em transferência no período</td>
              <td>{{nPadraoTraco(afericao_lucro.transferencias.total_periodo_1, 2)}}</td>
              <td>{{nPadraoTraco(afericao_lucro.transferencias.total_periodo_2, 2)}}</td>
              <td class="cor-enfase-2">{{nPadraoTraco(afericao_lucro.transferencias.resultado, 2)}}</td>
              <td style="text-align: center">
                {{nPadraoTraco(afericao_lucro.transferencias.percentual, 2)}}
                <span v-show="nPadrao(afericao_lucro.transferencias.percentual) != '0'">%</span>
              </td>
            </tr>

            <tr class="linha-enfase">
              <td style="text-align: left; cursor:pointer;" @click="mostrar_ativo_investimento = !mostrar_ativo_investimento">
                <u><b>+ Investimentos realizados</b></u>
              </td>
              <td>{{nPadraoTraco(getTotaisPlanosAtivoInvestimento.total_periodo_1, 2)}}</td>
              <td>{{nPadraoTraco(getTotaisPlanosAtivoInvestimento.total_periodo_2, 2)}}</td>
              <td>{{nPadraoTraco(getTotaisPlanosAtivoInvestimento.resultado, 2)}}</td>
              <td style="text-align: center">
                {{nPadraoTraco(getTotaisPlanosAtivoInvestimento.percentual, 2)}}
                <span v-show="nPadrao(getTotaisPlanosAtivoInvestimento.percentual) != ''">%</span>
              </td>
            </tr>

            <tr
              :key="getKeyPlanoFinTabAtInvest(plano_financeiro.plano_financeiro_id + 'BALANCOATI')"
              v-for="plano_financeiro in getPlanosTipoAtivoInvestimento"
              v-show="mostrar_ativo_investimento && (plano_financeiro.tipo_plano == 'ATI')"
            >
              <td style="text-align: left">{{plano_financeiro.nome}}</td>
              <td>{{nPadraoTraco(plano_financeiro.total_periodo_1, 2)}}</td>
              <td>{{nPadraoTraco(plano_financeiro.total_periodo_2, 2)}}</td>
              <td class="cor-enfase-2">{{nPadraoTraco(plano_financeiro.resultado, 2)}}</td>
              <td style="text-align: center">
                {{nPadraoTraco(plano_financeiro.percentual, 2)}}
                <span v-show="nPadrao(plano_financeiro.percentual) != ''">%</span>
              </td>
            </tr>

            <!------------- PASSIVO ------------->
            <tr class="linha-enfase-principal">
              <td style="text-align: left">
                <strong>PASSIVO</strong>
              </td>
              <td>
                <strong>{{nPadraoTraco(getTotaisBalancoPassivo.total_periodo_1, 2)}}</strong>
              </td>
              <td>
                <strong>{{nPadraoTraco(getTotaisBalancoPassivo.total_periodo_2, 2)}}</strong>
              </td>
              <td>
                <strong>{{nPadraoTraco(getTotaisBalancoPassivo.resultado, 2)}}</strong>
              </td>
              <td style="text-align: center">
                <strong>
                  {{nPadraoTraco(getTotaisBalancoPassivo.percentual, 2)}}
                  <span v-show="nPadrao(getTotaisBalancoPassivo.percentual) != ''">%</span>
                </strong>
              </td>
            </tr>

            <tr class="linha-enfase">
              <td style="text-align: left; cursor:pointer;" @click="mostrar_passivo_operacional = !mostrar_passivo_operacional">
                <u><b>- Operacional</b></u>
              </td>
              <td>{{nPadraoTraco(getTotaisPassivoOperacional.total_periodo_1, 2)}}</td>
              <td>{{nPadraoTraco(getTotaisPassivoOperacional.total_periodo_2, 2)}}</td>
              <td>{{nPadraoTraco(getTotaisPassivoOperacional.resultado, 2)}}</td>
              <td style="text-align: center">
                {{nPadraoTraco(getTotaisPassivoOperacional.percentual, 2)}}
                <span v-show="nPadrao(getTotaisPassivoOperacional.percentual) != ''">%</span>
              </td>
            </tr>

            <tr
              v-for="financeiro_pagar in afericao_lucro.financeiros_pagar"
              :key="getKeyPlanoFinPassivoOperacional(financeiro_pagar.plano_financeiro_id + 'BALANCOPAO')"
              v-show="mostrar_passivo_operacional && (financeiro_pagar.selecionado == 'PAO')"
            >
              <td style="text-align: left">{{financeiro_pagar.nome}}</td>
              <td>{{nPadraoTraco(financeiro_pagar.total_periodo_1, 2)}}</td>
              <td>{{nPadraoTraco(financeiro_pagar.total_periodo_2, 2)}}</td>
              <td class="cor-enfase-2">{{nPadraoTraco(financeiro_pagar.resultado, 2)}}</td>
              <td style="text-align: center">
                {{nPadraoTraco(financeiro_pagar.percentual, 2)}}
                <span v-show="nPadrao(financeiro_pagar.percentual) != ''">%</span>
              </td>
            </tr>

            <tr class="linha-enfase">
              <td style="text-align: left; cursor: pointer;" @click="mostrar_passivo_investimento = !mostrar_passivo_investimento">
                <u><b>- Dívidas com investimentos</b></u>
              </td>
              <td>{{nPadraoTraco(getTotaisPlanosPassivoInvestimento.total_periodo_1, 2)}}</td>
              <td>{{nPadraoTraco(getTotaisPlanosPassivoInvestimento.total_periodo_2, 2)}}</td>
              <td>{{nPadraoTraco(getTotaisPlanosPassivoInvestimento.resultado, 2)}}</td>
              <td style="text-align: center">
                {{nPadraoTraco(getTotaisPlanosPassivoInvestimento.percentual, 2)}}
                <span v-show="nPadrao(getTotaisPlanosPassivoInvestimento.percentual) != ''">%</span>
              </td>
            </tr>

            <tr
              v-for="financeiro_pagar in afericao_lucro.financeiros_pagar"
              :key="getKeyPlanoFinPassivoOperacional(financeiro_pagar.plano_financeiro_id + 'BALANCOPAI')"
              v-show="mostrar_passivo_investimento && (financeiro_pagar.selecionado == 'PAI')"
            >
              <td style="text-align: left">{{financeiro_pagar.nome}}</td>
              <td>{{nPadraoTraco(financeiro_pagar.total_periodo_1, 2)}}</td>
              <td>{{nPadraoTraco(financeiro_pagar.total_periodo_2, 2)}}</td>
              <td class="cor-enfase-2">{{nPadraoTraco(financeiro_pagar.resultado, 2)}}</td>
              <td style="text-align: center">
                {{nPadraoTraco(financeiro_pagar.percentual, 2)}}
                <span v-show="nPadrao(financeiro_pagar.percentual) != ''">%</span>
              </td>
            </tr>

            <tr class="linha-enfase-principal" style="cursor: pointer" @click="mostrar_socios = !mostrar_socios">
              <td style="text-align: left">
                <strong>SÓCIOS</strong>
              </td>
              <td>
                <strong>{{nPadraoTraco(getTotaisBalancoDistribuicaoLucro.total_periodo_1, 2)}}</strong>
              </td>
              <td>
                <strong>{{nPadraoTraco(getTotaisBalancoDistribuicaoLucro.total_periodo_2, 2)}}</strong>
              </td>
              <td>
                <strong>{{nPadraoTraco(getTotaisBalancoDistribuicaoLucro.resultado, 2)}}</strong>
              </td>
              <td style="text-align: center">
                <strong>
                  {{nPadraoTraco(getTotaisBalancoDistribuicaoLucro.percentual, 2)}}
                  <span v-show="nPadrao(getTotaisBalancoDistribuicaoLucro.percentual) != ''">%</span>
                </strong>
              </td>
            </tr>

            <tr
              :key="getKeyPlanoFinTabDistLucro(plano_financeiro.plano_financeiro_id + 'BALANCOSOC')"
              v-for="plano_financeiro in getPlanosTipoDistribuicaoLucro"
              v-show="mostrar_socios && (plano_financeiro.tipo_plano == 'DLU')"
            >
              <td style="text-align: left">{{plano_financeiro.nome}}</td>
              <td>{{nPadraoTraco(plano_financeiro.total_periodo_1, 2)}}</td>
              <td>{{nPadraoTraco(plano_financeiro.total_periodo_2, 2)}}</td>
              <td class="cor-enfase-2">{{nPadraoTraco(plano_financeiro.resultado, 2)}}</td>
              <td style="text-align: center">
                {{nPadraoTraco(plano_financeiro.percentual, 2)}}
                <span v-show="nPadrao(plano_financeiro.percentual) != ''">%</span>
              </td>
            </tr>

            <tr class="cor-enfase w3-padding">
              <th style="text-align: left">RESULTADO OPERACIONAL</th>
              <th>{{nPadraoTraco(getTotaisBalancoResultado.total_periodo_1, 2)}}</th>
              <th>{{nPadraoTraco(getTotaisBalancoResultado.total_periodo_2, 2)}}</th>
              <th>{{nPadraoTraco(getTotaisBalancoResultado.resultado, 2)}}</th>
              <th style="text-align: center">
                {{nPadraoTraco(getTotaisBalancoResultado.percentual, 2)}}
                <span v-show="nPadrao(getTotaisBalancoResultado.percentual) != ''">%</span>
              </th>
            </tr>


            <tr  class="linha-enfase-principal" v-show="nPadrao(getTotaisPrejuizo.total_periodo_1 + getTotaisPrejuizo.total_periodo_2, 2) != nPadrao(0, 2)">
              <td style="text-align: left; cursor:pointer;" @click="mostrar_prejuizo = !mostrar_prejuizo">
                <strong>- PREJUIZO</strong>
              </td>
              <td>
                <strong>{{nPadraoTraco(getTotaisPrejuizo.total_periodo_1, 2)}}</strong>
              </td>
              <td>
                <strong>{{nPadraoTraco(getTotaisPrejuizo.total_periodo_2, 2)}}</strong>
              </td>
              <td>
                <strong>{{nPadraoTraco(getTotaisPrejuizo.resultado, 2)}}</strong>
              </td>
              <td style="text-align: center">
                <strong>
                  {{nPadraoTraco(getTotaisPrejuizo.percentual, 2)}}
                  <span v-show="nPadrao(getTotaisPrejuizo.percentual) != ''">%</span>
                </strong>
              </td>
            </tr>

            <tr
              :key="'prejuizo' + prejuizo.tipo"
              v-for="prejuizo in getMovimentosPrejuizo()"
              v-show="mostrar_prejuizo"
            >
              <td style="text-align: left">{{prejuizo.descricao}}</td>
              <td>{{nPadraoTraco(prejuizo.total_periodo_1, 2)}}</td>
              <td>{{nPadraoTraco(prejuizo.total_periodo_2, 2)}}</td>
              <td class="cor-enfase-2">{{nPadraoTraco(prejuizo.resultado, 2)}}</td>
              <td style="text-align: center">
                {{nPadraoTraco(prejuizo.percentual, 2)}}
                <span v-show="nPadrao(prejuizo.percentual) != ''">%</span>
              </td>
            </tr>

            <tr class="cor-enfase-final">
              <td style="text-align: left">RESULTADO</td>
              <td>{{nPadraoTraco(getTotalFinal.total_periodo_1, 2)}}</td>
              <td>{{nPadraoTraco(getTotalFinal.total_periodo_2, 2)}}</td>
              <td>{{nPadraoTraco(getTotalFinal.resultado, 2)}}</td>
              <td style="text-align: center">
                {{nPadraoTraco(getTotalFinal.percentual, 2)}}
                <span v-show="nPadrao(getTotalFinal.percentual) != ''">%</span>
              </td>
            </tr>

          </tbody>
        </table>

      </div>
    </div>

    <!-- FIM -- BALANÇO FINANCEIRO -->

    <!-- MODAL DE CONFIGURAÇÕES INICIAIS -->
    <div id="modalConfiguracoesIniciais" class="w3-modal">
      <div class="w3-modal-content w3-animate-zoom">
        <header class="w3-container">
          <h4 class="texto-vermelho"><i class="fa fa-cog"></i> Configurações Iniciais</h4>
          <span @click="cancelarConfiguracoesIniciais()" class="w3-button w3-display-topright">&times;</span>
        </header>

        <div class="w3-row w3-container">
          <h5 class="texto-vermelho">Períodos</h5>
        </div>

        <div class="w3-row w3-container">
          <div class="w3-col m5 l3">
            <label>Inicial</label>
            <input
              type="date"
              class="w3-input w3-border"
              @change="atualizarPeriodoSelecionado(false)"
              v-model="configuracoes.periodo.data_inicial_1"
            >
          </div>

          <div class="w3-col m5 l3">
            <label class="w3-hide-small">&nbsp;</label>
            <input
              type="date"
              class="w3-input w3-border"
              @change="atualizarPeriodoSelecionado(false)"
              v-model="configuracoes.periodo.data_final_1"
            >
          </div>

          <div class="w3-col m5 l3">
            <label>Final</label>
            <input
              type="date"
              class="w3-input w3-border"
              @change="atualizarPeriodoSelecionado(false)"
              v-model="configuracoes.periodo.data_inicial_2"
            >
          </div>

          <div class="w3-col m5 l3">
            <label class="w3-hide-small">&nbsp;</label>
            <input
              type="date"
              class="w3-input w3-border"
              @change="atualizarPeriodoSelecionado(false)"
              v-model="configuracoes.periodo.data_final_2"
            >
          </div>
        </div>

        <div class="w3-row w3-container w3-margin-top">
          <h5 class="texto-vermelho">Empresas</h5>
          <label class="link-vermelho" @click="selecionarTodasEmpresas()">(Selecionar todas)</label>
        </div>        

        <div class="w3-container w3-margin-top">
          <div class="w3-hide-large">
            <div
              :key="getKeyListaEmpresaModal2Config(empresa.empresa_id)"
              v-for="empresa in configuracoes.empresas"
              v-cloak
            >
              <div class="w3-col l12 borda-pontilhada-base">
                <div class="checkbox-group">
                  <input
                    type="checkbox"
                    :id="buscarElementoEmpresa(empresa.empresa_id)"
                    class="switch-input"
                    v-model="empresa.selecionada"
                  >
                  <label class="switch-label" :for="buscarElementoEmpresa(empresa.empresa_id)">
                    <strong>{{empresa.empresa_id}} - {{empresa.nome_resumido}}</strong>
                  </label>
                </div>
              </div>
            </div>
          </div>

          <div class="w3-col l12 w3-margin-bottom w3-hide-small w3-hide-medium">
            <table class="w3-table-all">
              <tbody>
                <tr
                  :key="getKeyListaEmpresaModal3Config(empresa.empresa_id)"
                  v-for="empresa in configuracoes.empresas"
                  v-cloak
                >
                  <td>
                    <div class="checkbox-group">
                      <input
                        type="checkbox"
                        :id="buscarElementoEmpresa(empresa.empresa_id)"
                        class="switch-input"
                        v-model="empresa.selecionada"
                        :change="definirEmpresaSelecionada()"
                      >

                      <label class="switch-label" :for="buscarElementoEmpresa(empresa.empresa_id)">
                        <strong>{{empresa.empresa_id}} - {{empresa.nome_resumido}}</strong>
                      </label>                      
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="w3-container w3-center w3-margin-top">
          <button class="w3-button w3-theme" @click="gravarConfiguracoesIniciais()">
            <i class="fa fa-check"></i> Gravar configurações
          </button>
        </div>
      </div>
    </div>


    <!-- MODAL DE CONFIGURAÇÕES CONTAS -->
    <div id="modalConfiguracoesContas" class="w3-modal">
      <div class="w3-modal-content w3-animate-zoom">
        <header class="w3-container">
          <h4 class="texto-vermelho">
            <i class="fa fa-cog"></i> Configurações de Contas
          </h4>
          <span @click="cancelarConfiguracoesContas()" class="w3-button w3-display-topright">&times;</span>
        </header>

        <div class="w3-container" v-if="afericao_lucro">
          <label class="link-vermelho" style="cursor: pointer" @click="selecionarTodasContas()">(Selecionar todas)</label>

          <div class="w3-margin-top w3-hide-large">
            <div
              :key="getKeyListaContaModal2Config(conta.conta_id)"
              v-for="conta in afericao_lucro.contas"
              v-cloak
            >
              <div class="w3-col l12 borda-pontilhada-base" style="cursor: pointer">
                <div class="checkbox-group">
                  <input
                    type="checkbox"
                    :id="buscarElementoContaSmall(conta.conta_id)"
                    class="switch-input"
                    v-model="conta.selecionada"
                  >
                  <label class="switch-label" :for="buscarElementoContaSmall(conta.conta_id)">
                    <strong>{{conta.conta_id}}</strong>
                  </label>
                </div>

                <div class="w3-col s12">
                  <label class="w3-left titulo-small">Nome do portador&nbsp;&nbsp;</label>
                  <strong class="w3-left">{{conta.nome_portador}}</strong>
                </div>

                <div class="w3-col s12">
                  <label class="w3-left titulo-small">Empresa&nbsp;&nbsp;</label>
                  <strong class="w3-left">{{conta.empresa_id}} - {{conta.nome_empresa}}</strong>
                </div>

                <div class="w3-col s12">
                  <label class="w3-left titulo-small">Tipo analítico&nbsp;&nbsp;</label>
                  <strong class="w3-left">{{conta.tipo_analitico}}</strong>
                </div>
                
                <div class="w3-col s12">
                  <label class="w3-left titulo-small">Tipo conta&nbsp;&nbsp;</label>
                  <select class="w3-left w3-border" v-model="conta.tipo_conta">
                    <option value="CAI">Caixa/Bancária</option>
                    <option value="APL">Aplicação</option>
                  </select>
                </div>
              </div>
            </div>
          </div>

          <div class="w3-col l12 w3-margin-bottom w3-margin-top w3-hide-small w3-hide-medium">
            <table class="w3-table-all">
              <thead>
                <tr>
                  <th>Conta</th>
                  <th>Nome do portador</th>
                  <th>Empresa</th>
                  <th>Tipo analítico</th>
                  <th>Tipo conta</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  :key="getKeyListaContaModal3Config(conta.conta_id)"
                  v-for="conta in getTodasContas"
                  style="cursor: pointer"
                  v-cloak
                >
                  <td>
                    <div class="checkbox-group">
                      <input
                        type="checkbox"
                        :id="buscarElementoContaLarge(conta.conta_id)"
                        class="switch-input"
                        v-model="conta.selecionada"
                      >
                      <label class="switch-label" :for="buscarElementoContaLarge(conta.conta_id)">
                        <strong>{{conta.conta_id}}</strong>
                      </label>
                    </div>
                  </td>
                  <td>{{conta.nome_portador}}</td>
                  <td>{{conta.empresa_id}} - {{conta.nome_empresa}}</td>
                  <td>{{conta.tipo_analitico}}</td>
                  <td>
                    <select class="w3-input" v-model="conta.tipo_conta">
                      <option value="CAI">Caixa/Bancária</option>
                      <option value="APL">Aplicação</option>
                    </select>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="w3-container w3-center w3-margin-top">
          <button class="w3-button w3-theme" @click="gravarConfiguracoesContas()">
            <i class="fa fa-check"></i> Gravar configurações
          </button>
        </div>
      </div>
    </div>

    <!-- MODAL DE CONFIGURAÇÕES DE PLANO FINANCEIRO -->
    <div id="modalConfiguracoesPlanos" class="w3-modal">
      <div class="w3-modal-content w3-animate-zoom">
        <header class="w3-container">
          <h4 class="texto-vermelho">
            <i class="fa fa-cog"></i> Configurações da DRE
          </h4>
          <span @click="cancelarConfiguracoesPlanos()" class="w3-button w3-display-topright">&times;</span>
        </header>

        <div class="w3-container">
          <div class="w3-col m5 s12">
            <div class="checkbox-group">
              <input
                type="checkbox"
                id="checkMostrarTitulosDefinidosPrejuizo"
                class="switch-input"
                v-model="configuracoes.mostrar_titulos_definidos_prejuizo"
              >
              <label class="switch-label" for="checkMostrarTitulosDefinidosPrejuizo"><strong>Mostrar títulos definidos como prejuízo</strong></label>
            </div>
          </div>

          <div class="w3-col m4 s12">
            <div class="checkbox-group">
              <input
                type="checkbox"
                id="checkMostrarPercasEstoque"
                class="switch-input"
                v-model="configuracoes.mostrar_perca_estoque"
              >
              <label class="switch-label" for="checkMostrarPercasEstoque"><strong>Mostrar perca de estoque</strong></label>
            </div>
          </div>

          <!--  vai ser feito um dia!!!
          <div class="w3-col m3 s12">
            <label class="w3-block">Dados da venda</label>
            <select  class="w3-left w3-border w3-block" v-model="configuracoes.mostrar_vendas">
              <option value="">Não mostrar</option>
              <option value="FIN">Visão financeira</option>
              <option value="COM">Visão comercial</option>
            </select>
          </div>
          -->

        </div>  

        <div class="w3-col s12">
          <b class="w3-right">Página {{pagina_atual_plano}} / {{quantidade_paginas_plano}}</b>
        </div>

        <div class="w3-container">
          <button class="w3-col w3-btn w3-theme s3 m2" id="btPrimeira" @click="primeiraPaginaPlano">
            <i class="fa fa-angle-double-left"></i>
          </button>

          <button class="w3-col w3-btn w3-theme s3 m2" id="btAnterior" @click="paginaAnteriorPlano">
            <i class="fa fa-angle-left"></i>
          </button>

          <button class="w3-col w3-btn w3-theme s3 m2" id="btProxima" @click="proximaPaginaPlano">
            <i class="fa fa-angle-right"></i>
          </button>

          <button class="w3-col w3-btn w3-theme s3 m2" id="btUltima" @click="ultimaPaginaPlano">
            <i class="fa fa-angle-double-right"></i>
          </button>
        </div>

        <div v-if="afericao_lucro && afericao_lucro.planos_financeiros">
          <div
            class="w3-container borda-pontilhada-topo"
            :key="getKeyListaPlanFinConfigDRE(plano_financeiro.plano_financeiro_id)"
            v-show="podeMostrarItem(plano_financeiro.indice)"
            v-for="plano_financeiro in afericao_lucro.planos_financeiros"
            v-cloak
          >
            <div :class="buscarClassePlanoFinanceiro(plano_financeiro.tipo)">
              <strong>
                {{plano_financeiro.plano_financeiro_id}} - {{plano_financeiro.nome}}&nbsp;&nbsp;/&nbsp;&nbsp;
                Periodo 1:&nbsp;{{nPadrao(plano_financeiro.total_periodo_1, 2)}}&nbsp;&nbsp;/&nbsp;&nbsp;
                Periodo 2:&nbsp;{{nPadrao(plano_financeiro.total_periodo_2, 2)}}
              </strong>
            </div>

            <div class="w3-col l3 m6">
              <input
                type="radio"
                class="w3-radio"
                :id="buscarElementoPlanoFinanceiro(plano_financeiro.plano_financeiro_id, 'NEN')"
                :name="buscarElementoPlanoFinanceiro(plano_financeiro.plano_financeiro_id, '')"
                v-model="plano_financeiro.tipo_plano"
                value="NEN"
              >
              <label
                :for="buscarElementoPlanoFinanceiro(plano_financeiro.plano_financeiro_id, 'NEN')"
              >Não mostrar</label>
            </div>

            <div class="w3-col l3 m6">
              <input
                type="radio"
                class="w3-radio"
                :id="buscarElementoPlanoFinanceiro(plano_financeiro.plano_financeiro_id, 'ATI')"
                :name="buscarElementoPlanoFinanceiro(plano_financeiro.plano_financeiro_id, '')"
                v-model="plano_financeiro.tipo_plano"
                value="ATI"
              >
              <label
                :for="buscarElementoPlanoFinanceiro(plano_financeiro.plano_financeiro_id, 'ATI')"
              >Investimento realizado</label>
            </div>

            <div class="w3-col l3 m6">
              <input
                type="radio"
                class="w3-radio"
                :id="buscarElementoPlanoFinanceiro(plano_financeiro.plano_financeiro_id, 'DLU')"
                :name="buscarElementoPlanoFinanceiro(plano_financeiro.plano_financeiro_id, '')"
                v-model="plano_financeiro.tipo_plano"
                value="DLU"
              >
              <label
                :for="buscarElementoPlanoFinanceiro(plano_financeiro.plano_financeiro_id, 'DLU')"
              >Sócios</label>
            </div>
          </div>

          <div class="w3-container">
            <button class="w3-col w3-btn w3-theme s3" id="btPrimeira" @click="primeiraPaginaPlano">
              <i class="fa fa-angle-double-left"></i>
            </button>

            <button class="w3-col w3-btn w3-theme s3" id="btAnterior" @click="paginaAnteriorPlano">
              <i class="fa fa-angle-left"></i>
            </button>

            <button class="w3-col w3-btn w3-theme s3" id="btProxima" @click="proximaPaginaPlano">
              <i class="fa fa-angle-right"></i>
            </button>

            <button class="w3-col w3-btn w3-theme s3" id="btUltima" @click="ultimaPaginaPlano">
              <i class="fa fa-angle-double-right"></i>
            </button>
          </div>

          <div class="w3-container w3-center w3-margin-top">
            <button class="w3-button w3-theme" @click="gravarConfiguracoesPlanos()">
              <i class="fa fa-check"></i> Gravar configurações
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- MODAL DE CONFIGURAÇÕES DE FINANCEIROS A PAGAR -->
    <div id="modalConfiguracoesFinanceirosPagar" class="w3-modal">
      <div class="w3-modal-content w3-animate-zoom">
        <header class="w3-container">
          <h4 class="texto-vermelho">
            <i class="fa fa-cog"></i> Configurações de Financeiros a Pagar
          </h4>
          <span
            @click="cancelarConfiguracoesFinanceirosPagar()"
            class="w3-button w3-display-topright"
          >&times;</span>
        </header>

        <div class="w3-col s12">
          <b
            class="w3-right"
          >Página {{pagina_atual_financeiros_pag}} / {{quantidade_paginas_financeiros_pag}}</b>
        </div>

        <div class="w3-container">
          <button
            class="w3-col w3-btn w3-theme s3 m2"
            id="btPrimeira"
            @click="primeiraPaginaFinanceirosPag"
          >
            <i class="fa fa-angle-double-left"></i>
          </button>

          <button
            class="w3-col w3-btn w3-theme s3 m2"
            id="btAnterior"
            @click="paginaAnteriorFinanceirosPag"
          >
            <i class="fa fa-angle-left"></i>
          </button>

          <button
            class="w3-col w3-btn w3-theme s3 m2"
            id="btProxima"
            @click="proximaPaginaFinanceirosPag"
          >
            <i class="fa fa-angle-right"></i>
          </button>

          <button
            class="w3-col w3-btn w3-theme s3 m2"
            id="btUltima"
            @click="ultimaPaginaFinanceirosPag"
          >
            <i class="fa fa-angle-double-right"></i>
          </button>
        </div>

        <div v-if="afericao_lucro && afericao_lucro.financeiros_pagar">
          <div
            class="w3-container borda-pontilhada-topo"
            :key="getKeyListaConfigContasPagar(conta_pagar.plano_financeiro_id)"
            v-show="podeMostrarItemFinanceirosPagar(conta_pagar.indice)"
            v-for="conta_pagar in afericao_lucro.financeiros_pagar"
            v-cloak
          >
            <div class="w3-col l12 m12">
              <strong>
                {{mostrarPlanoContasPagar(conta_pagar.plano_financeiro_id)}} {{conta_pagar.nome}}&nbsp;&nbsp;/&nbsp;&nbsp;
                Periodo 1:&nbsp;{{nPadrao(conta_pagar.total_periodo_1, 2)}}&nbsp;&nbsp;/&nbsp;&nbsp;
                Periodo 2:&nbsp;{{nPadrao(conta_pagar.total_periodo_2, 2)}}
              </strong>
            </div>

            <div class="w3-col l3 m6">
              <input
                type="radio"
                class="w3-radio"
                :id="buscarElementoFinanceiroPagar(conta_pagar.plano_financeiro_id, 'NEN')"
                :name="buscarElementoFinanceiroPagar(conta_pagar.plano_financeiro_id, '')"
                v-model="conta_pagar.selecionado"
                value="NEN"
              >
              <label
                :for="buscarElementoFinanceiroPagar(conta_pagar.plano_financeiro_id, 'NEN')"
              >Não mostrar</label>
            </div>

            <div class="w3-col l3 m6">
              <input
                type="radio"
                class="w3-radio"
                :id="buscarElementoFinanceiroPagar(conta_pagar.plano_financeiro_id, 'PAO')"
                :name="buscarElementoFinanceiroPagar(conta_pagar.plano_financeiro_id, '')"
                v-model="conta_pagar.selecionado"
                value="PAO"
              >
              <label
                :for="buscarElementoFinanceiroPagar(conta_pagar.plano_financeiro_id, 'PAO')"
              >Passivo operacional</label>
            </div>

            <div class="w3-col l3 m6">
              <input
                type="radio"
                class="w3-radio"
                :id="buscarElementoFinanceiroPagar(conta_pagar.plano_financeiro_id, 'PAI')"
                :name="buscarElementoFinanceiroPagar(conta_pagar.plano_financeiro_id, '')"
                v-model="conta_pagar.selecionado"
                value="PAI"
              >
              <label
                :for="buscarElementoFinanceiroPagar(conta_pagar.plano_financeiro_id, 'PAI')"
              >Passivo investimento</label>
            </div>
          </div>

          <div class="w3-container">
            <button
              class="w3-col w3-btn w3-theme s3"
              id="btPrimeira"
              @click="primeiraPaginaFinanceirosPag"
            >
              <i class="fa fa-angle-double-left"></i>
            </button>

            <button
              class="w3-col w3-btn w3-theme s3"
              id="btAnterior"
              @click="paginaAnteriorFinanceirosPag"
            >
              <i class="fa fa-angle-left"></i>
            </button>

            <button
              class="w3-col w3-btn w3-theme s3"
              id="btProxima"
              @click="proximaPaginaFinanceirosPag"
            >
              <i class="fa fa-angle-right"></i>
            </button>

            <button
              class="w3-col w3-btn w3-theme s3"
              id="btUltima"
              @click="ultimaPaginaFinanceirosPag"
            >
              <i class="fa fa-angle-double-right"></i>
            </button>
          </div>

          <div class="w3-container w3-center w3-margin-top">
            <button class="w3-button w3-theme" @click="gravarConfiguracoesFinanceirosPagar()">
              <i class="fa fa-check"></i> Gravar configurações
            </button>
          </div>
        </div>
      </div>
    </div>


    <!-- MODAL DE CONFIGURAÇÕES DE FINANCEIROS A RECEBER -->
    <div id="modalConfiguracoesFinanceirosReceber" class="w3-modal">
      <div class="w3-modal-content w3-animate-zoom">
        <header class="w3-container">
          <h4 class="texto-vermelho">
            <i class="fa fa-cog"></i> Configurações de Financeiros a Receber
          </h4>

          <button class="w3-button w3-theme w3-block" @click="abrirModalPesquisaCadastros">
            <i class="fa fa-cog"></i> Omitir cadastro
          </button>

          <span
            @click="cancelarConfiguracoesFinanceirosReceber()"
            class="w3-button w3-display-topright"
          >&times;</span>
        </header>
        
        <div class="w3-container" v-if="configuracoes && configuracoes.usuarios_omitir_contas_receber">
          <strong class="w3-block">Cadastros omitidos na consulta de contas a receber</strong>
          
          <label v-if="configuracoes.usuarios_omitir_contas_receber.length == 0" class="w3-block">
            Nenhum
          </label>
          
          <table class="w3-table-all" v-if="this.configuracoes.usuarios_omitir_contas_receber.length != 0">
            <thead>
              <tr>
                <th>Cadastro</th>
                <th class="sem-quebra">CPF/CNPJ</th>
                <th>&nbsp;</th>
              </tr>
            </thead>
            <tbody>
              <tr 
                class="label-clicavel" 
                :key="cadastro.cadastro_id" 
                v-for="cadastro in configuracoes.usuarios_omitir_contas_receber">

                <td>{{cadastro.cadastro_id}} - {{cadastro.nome_razao_social}}</td>
                <td class="sem-quebra">{{cadastro.cpf_cnpj}}</td>
                <th>
                  <button 
                    class="w3-button w3-theme w3-center" 
                    @click="retirarCadastroListaOmissaoContasReceber(cadastro.cadastro_id)">X
                  </button>
                </th>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="w3-container" v-if="afericao_lucro && alterou_cadastros_contas_receber">
          <div class="w3-container w3-center w3-margin-top">
            <button class="w3-button w3-theme" @click="reprocessarFinanceirosReceber()">
              <i class="fas fa-sync-alt"></i> Reprocessar financeiros a receber
            </button>
          </div>
        </div>

        <div class="w3-container" v-if="!afericao_lucro || !alterou_cadastros_contas_receber">
          <div class="w3-container w3-center w3-margin-top">
            <button class="w3-button w3-theme" @click="gravarConfiguracoesFinanceirosReceber()">
              <i class="fa fa-check"></i> Gravar configurações
            </button>
          </div>
        </div>

      </div>
    </div>

    
    <!-- MODAL DE CONFIGURAÇÕES DE FINANCEIROS A PAGAR -->
    <div id="modalConfiguracoesFinanceirosPagar2" class="w3-modal">
      <div class="w3-modal-content w3-animate-zoom">
        <header class="w3-container">
          <h4 class="texto-vermelho">
            <i class="fa fa-cog"></i> Configurações de Financeiros a Pagar
          </h4>

          <button class="w3-button w3-theme w3-block" @click="abrirModalPesquisaCadastrosPagar()">
            <i class="fa fa-cog"></i> Omitir cadastro
          </button>

          <span
            @click="cancelarConfiguracoesFinanceirosPagar2()"
            class="w3-button w3-display-topright"
          >&times;</span>
        </header>

        <div class="w3-container" v-if="configuracoes && configuracoes.usuarios_omitir_contas_pagar2">
          <strong class="w3-block">Cadastros omitidos na consulta de contas a pagar</strong>
          
          <label v-if="configuracoes.usuarios_omitir_contas_pagar2.length == 0" class="w3-block">
            <span>Nenhum</span>
          </label>
          
          <table class="w3-table-all" v-if="configuracoes.usuarios_omitir_contas_pagar2.length != 0">
            <thead>
              <tr>
                <th>Cadastro</th>
                <th class="sem-quebra">CPF/CNPJ</th>
                <th>&nbsp;</th>
              </tr>
            </thead>
            <tbody>
              <tr 
                class="label-clicavel" 
                :key="cadastro.cadastro_id" 
                v-for="cadastro in configuracoes.usuarios_omitir_contas_pagar2">

                <td>{{cadastro.cadastro_id}} - {{cadastro.nome_razao_social}}</td>
                <td class="sem-quebra">{{cadastro.cpf_cnpj}}</td>
                <th>
                  <button 
                    class="w3-button w3-theme w3-center" 
                    @click="retirarCadastroListaOmissaoContasPagar2(cadastro.cadastro_id)">X
                  </button>
                </th>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="w3-container" v-if="afericao_lucro && alterou_cadastros_contas_pagar2">
          <div class="w3-container w3-center w3-margin-top">
            <button class="w3-button w3-theme" @click="reprocessarFinanceirosPagar2()">
              <i class="fas fa-sync-alt"></i> Reprocessar financeiros a pagar
            </button>
          </div>
        </div>

        <div class="w3-container" v-if="!afericao_lucro || !alterou_cadastros_contas_pagar2">
          <div class="w3-container w3-center w3-margin-top">
            <button class="w3-button w3-theme" @click="gravarConfiguracoesFinanceirosPagar2()">
              <i class="fa fa-check"></i> Gravar configurações
            </button>
          </div>
        </div>

      </div>
    </div>

    <pesquisa-cadastros
      ref="pesquisaCadastros"
      pesquisaPadrao="CPF"
      @confirmar="selecionarCadastroOmitirContasReceber">
    </pesquisa-cadastros>

    <pesquisa-cadastros
      ref="pesquisaCadastrosPagar"
      pesquisaPadrao="CPF"
      @confirmar="selecionarCadastroOmitirContasPagar">
    </pesquisa-cadastros>

  </div>
</template>

<script>
import moment from "moment"
import NavMenu from "@/components/Menu"
import toastr from "toastr"
import { exists } from "fs"
import PesquisaCadastros from "@/components/Pesquisas/PesquisaCadastros"
import REmpresa from '@/components/Rest/REmpresa'
import RAfericaoLucro from '@/components/Rest/RAfericaoLucro'

export default {
  name: "AfericaoLucro",
  components: {
    NavMenu,
    PesquisaCadastros
  },
  data() {
    return {
      api: process.env.API,
      processando: false,
      configuracoes: {},
      todas_empresas: [],
      mostrar_periodo: false,
      mostrar_empresas: false,
      mostrar_contas: false,

      mostrar_informacoes: true,

      afericao_lucro: undefined,

      pagina_atual_plano: 0,
      quantidade_paginas_plano: 0,

      pagina_atual_financeiros_pag: 0,
      quantidade_paginas_financeiros_pag: 0,

      quantidade_por_pagina: 20,

      periodo_exibicao_1: '',
      periodo_exibicao_2: '',

      mostrar_pesquisa_cadastros: false,
      mostrar_pesquisa_cadastros_pagar2: false,

      mostrar_caixas_bancos: false,
      mostrar_aplicacoes: false,
      mostrar_clientes: false,
      mostrar_estoque: false,
      mostrar_ativo_investimento: false,
      mostrar_passivo_operacional: false,
      mostrar_passivo_investimento: false,
      mostrar_prejuizo: false,
      mostrar_socios: false,

      alterou_cadastros_contas_receber: false,
      alterou_cadastros_contas_pagar2: false,

      c_configuracoes_afericao_lucro: 'configuracoes-afericao-lucro'
    }
  },
  methods: {
    abrirModalPesquisaCadastros() {
      this.$refs.pesquisaCadastros.abrir();
    },

    abrirModalPesquisaCadastrosPagar() {
      this.$refs.pesquisaCadastrosPagar.abrir();
    },

    ajustarExibicao(ativar) {
      this.mostrar_caixas_bancos = ativar
      this.mostrar_aplicacoes = ativar
      this.mostrar_clientes = ativar
      this.mostrar_estoque = ativar
      this.mostrar_ativo_investimento = ativar
      this.mostrar_passivo_operacional = ativar
      this.mostrar_passivo_investimento = ativar
      this.mostrar_prejuizo = ativar
      this.mostrar_socios = ativar
    },

    buscarConfiguracoesAfericaoLucro() {
      try {
        if (!localStorage.getItem(this.c_configuracoes_afericao_lucro)) {
          this.aplicarConfiguracoesPadrao()
          return
        }
          
        this.configuracoes = JSON.parse(localStorage.getItem(this.c_configuracoes_afericao_lucro))

        /* ---- empresas ---- */
        let empresas_selecionadas = JSON.parse(JSON.stringify(this.todas_empresas))

        for (let i = 0; i < empresas_selecionadas.length; i++) {
          empresas_selecionadas[i].selecionada = true

          for (let j = 0; j < this.configuracoes.empresas.length; j++) {
            if (empresas_selecionadas[i].empresa_id == this.configuracoes.empresas[j].empresa_id) {
              empresas_selecionadas[i].selecionada = this.configuracoes.empresas[j].selecionada
              break
            }
          }
        }

        this.configuracoes.empresas = JSON.parse(JSON.stringify(empresas_selecionadas))

        this.definirEmpresaSelecionada()
        this.atualizarPeriodoSelecionado(false)

        if (!this.configuracoes.usuarios_omitir_contas_receber) {
          this.configuracoes.usuarios_omitir_contas_receber = []
        }
      } 
      catch (erro) {
        console.log(erro)
      }
    },

    temTransferencia(transferencias) {
      try {
        let total1 = parseFloat(transferencias.total_periodo_1);
        let total2 = parseFloat(transferencias.total_periodo_2);

        if (total1 + total2 > 0) {
          return true;
        }
        else {
          return false;
        }
      }
      catch(e) {
        return false;
      }
    },

    ajustarPaginacaoContasPagarDRE: function() {
      if (this.afericao_lucro.financeiros_pagar) {
        for (let i = 0; i < this.afericao_lucro.financeiros_pagar.length; i++) {
          if (!this.afericao_lucro.financeiros_pagar[i].plano_financeiro_id) {
            this.afericao_lucro.financeiros_pagar[i].nome = 'Sem plano financeiro'
          }

          this.afericao_lucro.financeiros_pagar[i].indice = i + 1
        }
      }

      if (this.afericao_lucro.planos_financeiros) {
        for (let i = 0; i < this.afericao_lucro.planos_financeiros.length; i++) {
          this.afericao_lucro.planos_financeiros[i].indice = i + 1
        }
      }

      this.pagina_atual_plano = 1
      this.pagina_atual_financeiros_pag = 1

      if (this.afericao_lucro.financeiros_pagar) {
        if (this.afericao_lucro.financeiros_pagar.length < this.quantidade_por_pagina) {
          this.quantidade_paginas_financeiros_pag = 1
        } else {
          this.quantidade_paginas_financeiros_pag = Math.trunc(
            this.afericao_lucro.financeiros_pagar.length / this.quantidade_por_pagina
          )

          if (this.afericao_lucro.financeiros_pagar.length % this.quantidade_por_pagina > 0) {
            this.quantidade_paginas_financeiros_pag += 1
          }
        }
      }

      if (this.afericao_lucro.planos_financeiros) {
        if (this.afericao_lucro.planos_financeiros.length < this.quantidade_por_pagina) {
          this.quantidade_paginas_plano = 1
        } else {
          this.quantidade_paginas_plano = Math.trunc(
            this.afericao_lucro.planos_financeiros.length / this.quantidade_por_pagina
          )

          if (this.afericao_lucro.planos_financeiros.length % this.quantidade_por_pagina > 0) {
            this.quantidade_paginas_plano += 1
          }
        }
      }
    },

    buscarClasseCorPlanoFinanceiro(tipo) {
      if (tipo == 'R') {
        return 'cor-verde ';
      } else if (tipo == 'D') {
        return 'cor-vermelha ';
      }
    },

    buscarClassePlanoFinanceiro(tipo) {
      return 'w3-col l12 m12 ' + this.buscarClasseCorPlanoFinanceiro(tipo);
    },

    aplicarConfiguracoesPadrao() {
      /* Período inicial */
      let x_data_inicial_1 = new Date()
      x_data_inicial_1.setDate(1)
      x_data_inicial_1.setMonth(0)
      x_data_inicial_1.setFullYear(x_data_inicial_1.getFullYear() - 1)

      let x_data_final_1 = new Date()
      x_data_final_1.setFullYear(x_data_final_1.getFullYear() - 1)

      /* Período final */
      let x_data_inicial_2 = new Date()
      x_data_inicial_2.setDate(1)
      x_data_inicial_2.setMonth(0)

      let x_data_final_2 = new Date()

      this.configuracoes = {
        periodo: {
          periodo_selecionado_1: '1º período indefinido',
          periodo_selecionado_2: '2º período indefinido',
          data_inicial_1: this.dateToString(x_data_inicial_1),
          data_final_1: this.dateToString(x_data_final_1),
          data_inicial_2: this.dateToString(x_data_inicial_2),
          data_final_2: this.dateToString(x_data_final_2)
        },

        empresas: JSON.parse(JSON.stringify(this.todas_empresas)),
        financeiros_pagar: [],
        mostrar_titulos_definidos_prejuizo: true,
        mostrar_perca_estoque: true,
        mostrar_vendas: '',
        usuarios_omitir_contas_receber: [],
        contas: []
      }

      this.atualizarPeriodoSelecionado(false);
      this.verificarDadosConfiguracoes(false);
    },

    fecharModalConfiguracoesIniciais() {
      this.mostrar_informacoes = true
      $('#modalConfiguracoesIniciais').removeAttr('style').hide()
    },

    mostrarModalConfiguracoesIniciais() {
      this.mostrar_informacoes = false
      $('#modalConfiguracoesIniciais').toggle(100)
    },

    gravarConfiguracoesIniciais() {
      if (this.verificarDadosConfiguracoes(true)) {
        if (this.afericao_lucro) {
          this.afericao_lucro = JSON.parse(JSON.stringify(this.afericao_lucro))
        }

        this.fecharModalConfiguracoesIniciais()
      }
    },

    cancelarConfiguracoesIniciais() {
      this.verificarDadosConfiguracoes(false)
      this.fecharModalConfiguracoesIniciais()
    },

    mostrarModalConfiguracoesContas() {
      this.mostrar_informacoes = false
      $('#modalConfiguracoesContas').toggle(100)
    },

    cancelarConfiguracoesContas() {
      this.verificarDadosConfiguracoes(false)
      this.fecharModalConfiguracoesContas()
    },

    gravarConfiguracoesContas() {
      if (this.verificarDadosConfiguracoes(true)) {
        if (this.afericao_lucro) {
          this.afericao_lucro = JSON.parse(JSON.stringify(this.afericao_lucro))
        }

        this.fecharModalConfiguracoesContas()
      }
    },

    fecharModalConfiguracoesContas() {
      this.mostrar_informacoes = true
      $('#modalConfiguracoesContas').removeAttr('style').hide()
    },

    perguntarRedefinirFiltrosIniciais() {
      swal({
        title: 'Atenção!',
        text: 'Após as alterações o relatório terá processado novamente. NENHUMA CONFIGURAÇÃO SERÁ PERIDA, deseja continuar?',
        icon: 'warning',
        buttons: {
          sim: 'Sim',
          nao: 'Não',
        }
      })
      .then(
          (value) => {
          switch (value) {
            case 'sim':
              this.redefinirFiltrosIniciais()
              break    
            default:
              return
          }
        }
      )
    },

    redefinirFiltrosIniciais() {
      this.afericao_lucro = undefined
      this.buscarConfiguracoesAfericaoLucro()
    },

    mostrarModalConfiguracoesPlanos() {
      if (!this.afericao_lucro.planos_financeiros) {
        toastr.error('A DRE não tem dados no período selecionado!')
        return
      }

      this.mostrar_informacoes = false;
      $('#modalConfiguracoesPlanos').toggle(100)
    },

    fecharModalConfiguracoesPlanos() {
      this.mostrar_informacoes = true
      $('#modalConfiguracoesPlanos').removeAttr('style').hide()
    },

    mostrarModalConfiguracoesFinanceirosPagar() {
      if (!this.afericao_lucro.financeiros_pagar) {
        toastr.error('Nenhum financeiro a pagar foi encontrado no período selecionado!')
        return
      }

      this.mostrar_informacoes = false;
      $('#modalConfiguracoesFinanceirosPagar').toggle(100)
    },

    fecharModalConfiguracoesFinanceirosPagar() {
      this.mostrar_informacoes = true
      $('#modalConfiguracoesFinanceirosPagar').removeAttr('style').hide()
    },

    cancelarConfiguracoesFinanceirosPagar() {
      this.fecharModalConfiguracoesFinanceirosPagar()
    },

    gravarConfiguracoesFinanceirosPagar() {
      if (this.verificarDadosConfiguracoes(true)) {
        this.afericao_lucro = JSON.parse(JSON.stringify(this.afericao_lucro))
        this.fecharModalConfiguracoesFinanceirosPagar()
      }
    },

    mostrarModalConfiguracoesFinanceirosReceber() {
      this.mostrar_informacoes = false
      $('#modalConfiguracoesFinanceirosReceber').toggle(100)
    },

    mostrarModalConfiguracoesFinanceirosPagar2() {
      this.mostrar_informacoes = false;
      $("#modalConfiguracoesFinanceirosPagar2").toggle(100);
    },

    fecharModalConfiguracoesFinanceirosReceber() {
      this.mostrar_informacoes = true
      $('#modalConfiguracoesFinanceirosReceber').removeAttr('style').hide()
    },

    cancelarConfiguracoesFinanceirosReceber() {
      this.fecharModalConfiguracoesFinanceirosReceber()
    },

    fecharModalConfiguracoesFinanceirosPagar2() {
      this.mostrar_informacoes = true
      $("#modalConfiguracoesFinanceirosPagar2").removeAttr("style").hide()
    },

    cancelarConfiguracoesFinanceirosPagar2() {
      this.fecharModalConfiguracoesFinanceirosPagar2()
    },

    fecharModalConfiguracoesFinanceirosPagar2() {
      this.mostrar_informacoes = true
      $("#modalConfiguracoesFinanceirosPagar2").removeAttr("style").hide()
    },

    gravarConfiguracoesFinanceirosReceber() {
      if (this.verificarDadosConfiguracoes(true)) {

        if (this.afericao_lucro) {
          this.afericao_lucro = JSON.parse(JSON.stringify(this.afericao_lucro))
        }
        
        this.fecharModalConfiguracoesFinanceirosReceber()
      }
    },

    gravarConfiguracoesFinanceirosPagar2() {
      if (this.verificarDadosConfiguracoes(true)) {

        if (this.afericao_lucro) {
          this.afericao_lucro = JSON.parse(JSON.stringify(this.afericao_lucro))
        }
        
        this.fecharModalConfiguracoesFinanceirosPagar2()
      }
    },

    primeiraPaginaPlano: function() {
      this.pagina_atual_plano = 1
    },

    paginaAnteriorPlano: function() {
      if (this.pagina_atual_plano > 1) {
        this.pagina_atual_plano -= 1
      }
    },

    proximaPaginaPlano: function() {
      if (this.pagina_atual_plano < this.quantidade_paginas_plano) {
        this.pagina_atual_plano += 1
      }
    },

    ultimaPaginaPlano: function() {
      this.pagina_atual_plano = this.quantidade_paginas_plano
    },

    primeiraPaginaFinanceirosPag: function() {
      this.pagina_atual_financeiros_pag = 1
    },

    paginaAnteriorFinanceirosPag: function() {
      if (this.pagina_atual_financeiros_pag > 1) {
        this.pagina_atual_financeiros_pag -= 1
      }
    },

    proximaPaginaFinanceirosPag: function() {
      if (this.pagina_atual_financeiros_pag < this.quantidade_paginas_financeiros_pag) {
        this.pagina_atual_financeiros_pag += 1
      }
    },

    ultimaPaginaFinanceirosPag: function() {
      this.pagina_atual_financeiros_pag = this.quantidade_paginas_financeiros_pag;
    },

    podeMostrarItem: function(indice) {
      let item_final = this.pagina_atual_plano * this.quantidade_por_pagina
      let item_inicial = item_final - this.quantidade_por_pagina + 1

      return indice >= item_inicial && indice <= item_final
    },

    podeMostrarItemFinanceirosPagar: function(indice) {
      let item_final =
        this.pagina_atual_financeiros_pag * this.quantidade_por_pagina
      let item_inicial = item_final - this.quantidade_por_pagina + 1

      return indice >= item_inicial && indice <= item_final
    },

    cancelarConfiguracoesPlanos() {
      this.fecharModalConfiguracoesPlanos()
    },

    verificarDadosConfiguracoes(gravar_dispositivo) {
      let periodo = this.configuracoes.periodo

      this.atualizarPeriodoSelecionado(gravar_dispositivo)

      /* Sempre por último */
      if (gravar_dispositivo) {
        if (this.afericao_lucro && this.afericao_lucro.planos_financeiros) {
          this.configuracoes.planos_financeiros = []

          for (let i = 0; i < this.afericao_lucro.planos_financeiros.length; i++) {
            this.configuracoes.planos_financeiros.push({
              plano_financeiro_id: this.afericao_lucro.planos_financeiros[i].plano_financeiro_id,
              tipo_plano: this.afericao_lucro.planos_financeiros[i].tipo_plano
            })
          }
        }

        if (this.afericao_lucro && this.afericao_lucro.financeiros_pagar) {
          this.configuracoes.financeiros_pagar = [];

          for (let i = 0; i < this.afericao_lucro.financeiros_pagar.length; i++) {
            this.configuracoes.financeiros_pagar.push({
              plano_financeiro_id: this.afericao_lucro.financeiros_pagar[i].plano_financeiro_id,
              selecionado: this.afericao_lucro.financeiros_pagar[i].selecionado
            })
          }
        }

        if (this.afericao_lucro && this.afericao_lucro.contas) {
          this.configuracoes.contas = [];

          for (let i = 0; i < this.afericao_lucro.contas.length; i++) {
            if (!this.afericao_lucro.contas[i].selecionada) {
              continue
            }

            this.configuracoes.contas.push(JSON.parse(JSON.stringify(this.afericao_lucro.contas[i])))
          }
        }

        localStorage.setItem(this.c_configuracoes_afericao_lucro, JSON.stringify(this.configuracoes))
      }

      return true;
    },

    mostrarPlanoContasPagar(plano_financeiro_id) {
      if (plano_financeiro_id == '0.000') {
        return ''
      }
      else {
        return plano_financeiro_id + ' - '
      }
    },

    getKeyFinanceiroPagar(planoFinanceiroId) {
      return 'planoPagar' + planoFinanceiroId
    },

    getKeyListaEmpresas(empresaId) {
      return 'listaEmpresa' + empresaId
    },

    getKeyListaContaId(contaId) {
      return 'listaConta' + contaId
    },

    getKeyListaTabelaContaId(contaId) {
      return 'listaTabelaConta' + contaId
    },

    getKeyTipoSintFinReceber(tipoSintetico) {
      return 'tipoSinteticoFinReceber' + tipoSintetico
    },

    getKeyListaTipoSintFinRecTab(tipoSintetico) {
      return 'listaTipoSintFinRecTab' + tipoSintetico
    },

    getKeyEmpresaInventario(empresaId) {
      return 'empresaInventario' + empresaId
    },

    getKeyInventarioTabEmpresa(inventario) {
      let empresa_id = '';
      if (inventario.empresa_id) {
        empresa_id = 'I' + inventario.empresa_id;
      }
      else {
        empresa_id = 'T' + inventario.empresa_transferencia_id;
      }

      return 'inventarioTabEmpresa' + empresa_id + 'BALANCOINV';
    },

    getKeyPlanoFinAtInvest(planoFinanceiroId) {
      return 'planoFinAtInvest' + planoFinanceiroId
    },

    getKeyPlanoFinTabAtInvest(planoFinanceiroId) {
      return 'planoFinTabAtInvest' + planoFinanceiroId
    },

    getKeyPlanoFinDistLucro(planoFinanceiroId) {
      return 'planoFinDistLucro' + planoFinanceiroId
    },

    getKeyPlanoFinTabDistLucro(planoFinanceiroId) {
      return 'planoFinTabDistLucro' + planoFinanceiroId
    },

    getKeyPlanoFinPassivoOperacional(planoFinanceiroId) {
      return 'planoFinPassivoOperacional' + planoFinanceiroId
    },

    getKeyPlanoFinPassivoInvest(planoFinanceiroId) {
      return 'planoFinPassivoInvest' + planoFinanceiroId
    },

    getKeyPlanoFinTabPassivoInvest(planoFinanceiroId) {
      return 'planoFinTabPassivoInvest' + planoFinanceiroId
    },

    getKeyListaEmpresaModalConfig(empresaId) {
      return 'listaEmpresaModalConfig' + empresaId
    },

    getKeyListaEmpresaModal2Config(empresaId) {
      return 'listaEmpresaModal2Config' + empresaId
    },

    getKeyListaEmpresaModal3Config(empresaId) {
      return 'listaEmpresaModal3Config' + empresaId
    },

    getKeyListaContaModalConfig(contaId) {
      return 'listaContaModalConfig' + contaId
    },

    getKeyListaContaModal2Config(contaId) {
      return 'listaContaModal2Config' + contaId
    },

    getKeyListaContaModal3Config(contaId) {
      return 'listaContaModal3Config' + contaId
    },

    getKeyListaPlanFinConfigDRE(planoFinanceiroId) {
      return 'listaPlanFinConfigDRE' + planoFinanceiroId
    },

    getKeyListaConfigContasPagar(planoFinanceiroId) {
      return 'listaConfigContasPagar' + planoFinanceiroId
    },

    retirarCadastroListaOmissaoContasReceber(cadastro_id) {
      for (let i = 0; i < this.configuracoes.usuarios_omitir_contas_receber.length; i++) {

        if (this.configuracoes.usuarios_omitir_contas_receber[i].cadastro_id == cadastro_id) {
          this.configuracoes.usuarios_omitir_contas_receber.splice(i, 1)
          this.alterou_cadastros_contas_receber = true
          return
        }

      }
    },

    retirarCadastroListaOmissaoContasPagar2(cadastro_id) {
      for (let i = 0; i < this.configuracoes.usuarios_omitir_contas_pagar2.length; i++) {
        if (this.configuracoes.usuarios_omitir_contas_pagar2[i].cadastro_id == cadastro_id) {
          this.configuracoes.usuarios_omitir_contas_pagar2.splice(i, 1)
          this.alterou_cadastros_contas_pagar2 = true;
          return
        }
      }
    },

    selecionarCadastroOmitirContasReceber(cadastro) {
      if (!cadastro) {
        return
      }

      this.mostrar_pesquisa_cadastros = false

      if (!this.configuracoes.usuarios_omitir_contas_receber) {
        this.configuracoes.usuarios_omitir_contas_receber = []
      }

      for (let i = 0; i < this.configuracoes.usuarios_omitir_contas_receber.length; i++) {
        if (
          this.configuracoes.usuarios_omitir_contas_receber[i].cadastro_id ==
          cadastro.cadastro_id
        ) {
          return
        }
      }

      this.configuracoes.usuarios_omitir_contas_receber.push(
        {
          cadastro_id: cadastro.cadastro_id,
          cpf_cnpj: cadastro.cpf_cnpj,
          nome_razao_social: cadastro.nome_razao_social
        }
      )
      this.alterou_cadastros_contas_receber = true;
    },

    selecionarCadastroOmitirContasPagar(cadastro) {
      if (!cadastro) {
        return
      }

      this.mostrar_pesquisa_cadastros_pagar2 = false;

      if (!this.configuracoes.usuarios_omitir_contas_pagar2) {
        this.configuracoes.usuarios_omitir_contas_pagar2 = [];
      }

      for (let i = 0; i < this.configuracoes.usuarios_omitir_contas_pagar2.length; i++) {
        if (this.configuracoes.usuarios_omitir_contas_pagar2[i].cadastro_id == cadastro.cadastro_id) {
          return
        }
      }

      this.configuracoes.usuarios_omitir_contas_pagar2.push(
        {
          cadastro_id: cadastro.cadastro_id,
          cpf_cnpj: cadastro.cpf_cnpj,
          nome_razao_social: cadastro.nome_razao_social
        }
      );

      this.configuracoes = JSON.parse(JSON.stringify(this.configuracoes));

      this.alterou_cadastros_contas_pagar2 = true;
    },

    reprocessarFinanceirosReceber() {
      this.afericao_lucro = {}
      this.gravarConfiguracoesFinanceirosReceber()
      this.buscarDadosAfericaoLucro()
    },

    reprocessarFinanceirosPagar2() {
      this.afericao_lucro = {}
      this.gravarConfiguracoesFinanceirosPagar()
      this.buscarDadosAfericaoLucro()
    },

    atualizarPeriodoSelecionado(mostrar_excecao) {
      this.configuracoes.periodo.periodo_selecionado_1 = '1º período indefinido'
      this.configuracoes.periodo.periodo_selecionado_2 = '2º período indefinido'

      let periodo = this.configuracoes.periodo

      if (!periodo.data_inicial_1 || !periodo.data_final_1) {
        if (mostrar_excecao) {
          toastr.error('Informe um período inicial válido!')
        }
        return false
      }

      if (!periodo.data_inicial_2 || !periodo.data_final_2) {
        if (mostrar_excecao) {
          toastr.error('Informe um período final válido!')
        }
        return false
      }

      let dt1 = this.stringToDate(periodo.data_inicial_1)
      let dt2 = this.stringToDate(periodo.data_final_1)
      if (dt1 > dt2) {
        if (mostrar_excecao) {
          toastr.error('Período inicial: A data inicial não pode ser maior que a data final!')
        }
        return false
      }

      let dt3 = this.stringToDate(periodo.data_inicial_2)
      let dt4 = this.stringToDate(periodo.data_final_2)
      if (dt3 > dt4) {
        if (mostrar_excecao) {
          toastr.error('Período final: A data inicial não pode ser maior que a data final!')
        }
        return false
      }

      this.configuracoes.periodo.periodo_selecionado_1 = this.dateToStringBR(dt1) + ' a ' + this.dateToStringBR(dt2)
      this.configuracoes.periodo.periodo_selecionado_2 = this.dateToStringBR(dt3) + ' a ' + this.dateToStringBR(dt4)

      this.periodo_exibicao_1 = this.dateToStringBR(dt2)
      this.periodo_exibicao_2 = this.dateToStringBR(dt4)
    },

    gravarConfiguracoesPlanos() {
      if (this.verificarDadosConfiguracoes(true)) {
        this.afericao_lucro = JSON.parse(JSON.stringify(this.afericao_lucro))
        this.fecharModalConfiguracoesPlanos()
      }
    },

    stringToDate(dataStr) {
      let partes = dataStr.split('-')
      let retorno = new Date(partes[0], partes[1] - 1, partes[2])
      return retorno
    },

    dateToString(data) {
      let dia = data.getDate().toString().padStart(2, '0')
      let mes = (data.getMonth() + 1).toString().padStart(2, '0')
      let ano = data.getFullYear()
      return ano + '-' + mes + '-' + dia
    },

    dateToStringBR(data) {
      let dia = data.getDate().toString().padStart(2, '0')
      let mes = (data.getMonth() + 1).toString().padStart(2, '0')
      let ano = data.getFullYear()
      return dia + '/' + mes + '/' + ano
    },

    async buscarTodasEmpresas() {
      try {
        let retorno = await REmpresa.buscarTodasEmpresas(this.axios);
        if (retorno.houve_erro != 'N') {
          throw new Error(retorno.mensagem);
        }

        this.todas_empresas = JSON.parse(JSON.stringify(retorno.dados));
        this.buscarConfiguracoesAfericaoLucro();
      }
      catch(e) { 
        toastr.error('Não foi possível carregar as empresas! ' + e.message);
      }
    },

    async buscarDadosAfericaoLucro() {
      try {
        if (this.nenhumaEmpresaSelecionada()) {
          toastr.error('Selecione pelo menos uma empresa!')
          return;
        }

        let par_empresas_ids = []
        for (let i = 0; i < this.configuracoes.empresas.length; i++) {
          if (this.configuracoes.empresas[i].selecionada) {
            par_empresas_ids.push(this.configuracoes.empresas[i].empresa_id)
          }
        }

        let periodo_inicial = [
          this.dateToStringBR(
            this.stringToDate(this.configuracoes.periodo.data_inicial_1)
          ),
          this.dateToStringBR(
            this.stringToDate(this.configuracoes.periodo.data_final_1)
          )
        ];

        let periodo_final = [
          this.dateToStringBR(
            this.stringToDate(this.configuracoes.periodo.data_inicial_2)
          ),
          this.dateToStringBR(
            this.stringToDate(this.configuracoes.periodo.data_final_2)
          )
        ];

        let par_usuarios_omitir_contas_receber = []
        if (this.configuracoes.usuarios_omitir_contas_receber) {
          for (let i = 0; i < this.configuracoes.usuarios_omitir_contas_receber.length; i++) {
            par_usuarios_omitir_contas_receber.push(
              this.configuracoes.usuarios_omitir_contas_receber[i].cadastro_id
            )
          }
        }

        let par_usuarios_omitir_contas_pagar = []
        if (this.configuracoes.usuarios_omitir_contas_pagar2) {
          for (let i = 0; i < this.configuracoes.usuarios_omitir_contas_pagar2.length; i++) {
            par_usuarios_omitir_contas_pagar.push(this.configuracoes.usuarios_omitir_contas_pagar2[i].cadastro_id)
          }
        }

        let parametros = {
          tipo_busca: 'AFE',
          empresas_ids: par_empresas_ids,
          periodo_inicial: periodo_inicial,
          periodo_final: periodo_final,
          usuarios_omitir_contas_receber_ids: par_usuarios_omitir_contas_receber,
          usuarios_omitir_contas_pagar_ids: par_usuarios_omitir_contas_pagar
        }

        this.processando = true

        let retorno = await RAfericaoLucro.buscarAfericaoLucro1(this.axios, parametros);
        if (retorno.houve_erro != 'N') {
          throw new Error(retorno.mensagem);
        }

        this.afericao_lucro = JSON.parse(JSON.stringify(retorno.dados.afericao_lucro));

        /* ********************** AJUSTANDO EMPRESAS DO INVENTÁRIO ********************** */
        if (this.afericao_lucro.inventarios) {
          for (let i = 0; i < this.afericao_lucro.inventarios.length; i++) {
            for (let j = 0; j < this.todas_empresas.length; j++) {
              if (
                this.afericao_lucro.inventarios[i].empresa_id ==
                this.todas_empresas[j].empresa_id
              ) {
                this.afericao_lucro.inventarios[i].nome_resumido = (
                  this.todas_empresas[j].nome_resumido
                );
                break
              }

              if (
                this.afericao_lucro.inventarios[i].empresa_transferencia_id == 
                this.todas_empresas[j].empresa_id
              ) {
                this.afericao_lucro.inventarios[i].nome_resumido = this.todas_empresas[j].nome_resumido;
                break;
              }
            }
          }
        }

        /* ********************** AJUSTANDO PLANOS FINANCEIROS DA DRE ********************** */
        if (this.afericao_lucro.planos_financeiros) {
          for (let i = 0; i < this.afericao_lucro.planos_financeiros.length; i++) {
            this.afericao_lucro.planos_financeiros[i].indice = i + 1;
            this.afericao_lucro.planos_financeiros[i].tipo_plano = 'NEN';
          }
        }

        if (this.afericao_lucro.financeiros_pagar) {
          for (let i = 0; i < this.afericao_lucro.financeiros_pagar.length; i++) {
            if (!this.afericao_lucro.financeiros_pagar[i].plano_financeiro_id) {
              this.afericao_lucro.financeiros_pagar[i].nome = 'Sem plano financeiro';
            }
            this.afericao_lucro.financeiros_pagar[i].indice = i + 1;
          }
        }

        if (this.configuracoes.planos_financeiros && this.afericao_lucro.planos_financeiros) {
          for (let i = 0; i < this.afericao_lucro.planos_financeiros.length; i++) {
            for (let j = 0; j < this.configuracoes.planos_financeiros.length; j++) {
              if (
                this.afericao_lucro.planos_financeiros[i].plano_financeiro_id != 
                this.configuracoes.planos_financeiros[j].plano_financeiro_id
              ) {
                continue;
              }

              this.afericao_lucro.planos_financeiros[i].tipo_plano = (
                this.configuracoes.planos_financeiros[j].tipo_plano
              );

              if (!this.afericao_lucro.planos_financeiros[i].tipo_plano) {
                this.afericao_lucro.planos_financeiros[i].tipo_plano = 'NEN';
              }
              break
            }
          }
        }
        else {
          if (this.afericao_lucro.planos_financeiros) {
            for (let i = 0; i < this.afericao_lucro.planos_financeiros.length; i++) {
              if (this.afericao_lucro.planos_financeiros[i].plano_financeiro_id.length == 1) {
                if (this.afericao_lucro.planos_financeiros[i].tipo == 'D') {
                  this.afericao_lucro.planos_financeiros[i].tipo_plano = 'PAI'
                }
                else if (this.afericao_lucro.planos_financeiros[i].tipo == 'R') {
                  this.afericao_lucro.planos_financeiros[i].tipo_plano = 'ATI'
                }
              }
            }
          }
        }

        /* ********************** AJUSTANDO PLANOS FINANCEIROS DE CONTAS A PAGAR ********************** */
        if (this.afericao_lucro.financeiros_pagar && this.configuracoes.financeiros_pagar) {
          for (let i = 0; i < this.afericao_lucro.financeiros_pagar.length; i++) {
            for (let j = 0; j < this.configuracoes.financeiros_pagar.length; j++) {
              if (
                this.afericao_lucro.financeiros_pagar[i].plano_financeiro_id == 
                this.configuracoes.financeiros_pagar[j].plano_financeiro_id
              ) {
                this.afericao_lucro.financeiros_pagar[i].selecionado = (
                  this.configuracoes.financeiros_pagar[j].selecionado
                );
                break;
              }
            }
          }
        }
        else {
          this.configuracoes.financeiros_pagar = []

          if (this.afericao_lucro.financeiros_pagar) {
            for (let i = 0; i < this.afericao_lucro.financeiros_pagar.length; i++) {
              let sel = 'NEN'

              if (
                nPadrao(this.afericao_lucro.financeiros_pagar[i].resultado, 2) != 
                nPadrao(0, 2)
              ) {
                sel = 'PAO'
              }

              this.configuracoes.financeiros_pagar.push({
                plano_financeiro_id: this.afericao_lucro.financeiros_pagar[i].plano_financeiro_id,
                selecionado: sel
              })

              this.afericao_lucro.financeiros_pagar[i].selecionado = sel
            }
          }
        }

        /* ********************** AJUSTANDO CONTAS CAIXAS/BANCOS/APLICAÇÕES ********************** */
        if ((!this.configuracoes.contas) || (this.configuracoes.contas.length == 0)) {
          for (let i = 0; i < this.afericao_lucro.contas.length; i++) {
            this.configuracoes.contas.push(
              {
                conta_id: this.afericao_lucro.contas[i].conta_id,
                selecionada: true,
                tipo_conta: 'CAI'
              }
            )
          }
        }

        if (this.configuracoes.contas && this.afericao_lucro.contas) {
          for (let i = 0; i < this.afericao_lucro.contas.length; i++) {
            this.afericao_lucro.contas[i].tipo_conta = 'CAI'

            for (let j = 0; j < this.configuracoes.contas.length; j++) {
              if (this.afericao_lucro.contas[i].conta_id != this.configuracoes.contas[j].conta_id) {
                continue
              }

              this.afericao_lucro.contas[i].selecionada = this.configuracoes.contas[j].selecionada
              this.afericao_lucro.contas[i].tipo_conta = this.configuracoes.contas[j].tipo_conta
              break
            }
          }
        } 

        this.processando = false
        this.alterou_cadastros_contas_receber = false

        this.ajustarPaginacaoContasPagarDRE();
      }
      catch(e) {
        this.processando = false;
        toastr.error('Não foi possível processar os dados! ' + e.message);
      }
    },

    calcularPercentualAnaliseVertical(total_periodo_1, total_periodo_2) {
      let resultado = total_periodo_2 - total_periodo_1

      let percentual = 0
      if (
        nPadrao(total_periodo_1, 2) != nPadrao(total_periodo_2, 2) &&
        nPadrao(total_periodo_1, 2) != nPadrao(0, 2)
      ) {
        percentual = (resultado / total_periodo_1) * 100
        if (percentual < 0) {
          percentual = percentual * -1
        }

        if (total_periodo_2 < total_periodo_1) {
          percentual = percentual * -1
        }
      }

      let retorno = {
        resultado: resultado,
        percentual: percentual
      }

      return retorno
    },

    adicionarTotalizacaoFinanceiro(periodo, tipo_financeiro, total_geral) {
      for (let i = 0; i < this.resumo_financeiros.length; i++) {
        if (this.resumo_financeiros[i].tipo_sintetico != tipo_financeiro) {
          continue
        }

        if (periodo == 1) {
          this.resumo_financeiros[i].total_periodo_1 = total_geral
        } else {
          this.resumo_financeiros[i].total_periodo_2 = total_geral
        }

        break
      }
    },

    nenhumaEmpresaSelecionada() {
      if (!this.configuracoes) {
        return true
      }

      if (!this.configuracoes.empresas) {
        return true
      }

      for (let i = 0; i < this.configuracoes.empresas.length; i++) {
        if (this.configuracoes.empresas[i].selecionada) {
          return false
        }
      }

      return true;
    },

    todasEmpresasSelecionadas() {
      if (!this.configuracoes) {
        return false
      }

      if (!this.configuracoes.empresas) {
        return false
      }

      for (let i = 0; i < this.configuracoes.empresas.length; i++) {
        if (!this.configuracoes.empresas[i].selecionada) {
          return false
        }
      }

      return true
    },

    selecionarTodasEmpresas() {
      if (!this.configuracoes) {
        return
      }

      if (!this.configuracoes.empresas) {
        return
      }

      for (let i = 0; i < this.configuracoes.empresas.length; i++) {
        this.configuracoes.empresas[i].selecionada = true
      }

      this.mostrar_empresas = false
    },

    nenhumaContaSelecionada() {
      if (!this.afericao_lucro) {
        return true
      }

      if (!this.afericao_lucro.contas) {
        return true
      }

      for (let i = 0; i < this.afericao_lucro.contas.length; i++) {
        if (this.afericao_lucro.contas[i].selecionada) {
          return false
        }
      }

      return true
    },

    todasContasSelecionadas() {
      if (!this.afericao_lucro) {
        return false
      }

      if (!this.afericao_lucro.contas) {
        return false
      }

      for (let i = 0; i < this.afericao_lucro.contas.length; i++) {
        if (!this.afericao_lucro.contas[i].selecionada) {
          return false
        }
      }

      return true
    },

    selecionarTodasContas() {
      if (!this.afericao_lucro) {
        return
      }

      if (!this.afericao_lucro.contas) {
        return
      }

      for (let i = 0; i < this.afericao_lucro.contas.length; i++) {
        this.afericao_lucro.contas[i].selecionada = true
      }

      this.mostrar_contas = false
    },

    buscarElementoContaSmall(conta_id) {
      return 'contaSmall' + conta_id
    },

    buscarElementoContaLarge(conta_id) {
      return 'contaLarge' + conta_id
    },

    buscarElementoPlanoFinanceiro(planoFinanceiroId, complemento) {
      return 'planoFinanceiro' + planoFinanceiroId + complemento
    },

    buscarElementoFinanceiroPagar(planoFinanceiroId, complemento) {
      return 'financeiroPagar' + planoFinanceiroId + complemento
    },

    buscarElementoEmpresa(empresa_id) {
      return 'empresa' + empresa_id
    },

    definirEmpresaSelecionada() {
      let retorno = true
      for (let j = 0; j < this.configuracoes.empresas.length; j++) {
        retorno = this.configuracoes.empresas[j].selecionada
        if (!retorno) {
          break
        }
      }

      this.configuracoes.todas_empresas_selecionadas = retorno
    },

    nPadraoPercentual: function(val, casas_decimais) {
      if (!val) {
        return ''
      }

      let texto = nPadrao(val, casas_decimais);
      if (texto == '') {
        texto = ''
      } else {
        texto = '(' + texto + '%)'
      }

      return texto
    },

    nPadraoTraco: function(val, casas_decimais) {
      if (!val) {
        return ''
      }

      let texto = nPadrao(val, casas_decimais);
      if (texto == '') {
        texto = ''
      } else if (texto == nPadrao('0.00', casas_decimais)) {
        texto = '--'
      }

      return texto
    },

    nPadrao: function(val, casas_decimais) {
      if (!val) {
        return ''
      }

      let valor = Math.abs(val).toFixed(casas_decimais);
      let sinal = ''
      if (val < -0.001) {
        sinal = '-'
      }

      if (!valor) {
        return nPadrao(0, casas_decimais)
      }

      let numero

      if (casas_decimais == 0) {
        let formato = { minimumFractionDigits: casas_decimais };
        numero = parseInt(valor)
        return numero.toLocaleString('pt-BR', formato)
      } else {
        if (valor.length - casas_decimais - 1 >= 0 && valor.charAt(valor.length - casas_decimais - 1) == ',') {
          numero = parseFloat(valor.replace(',', '.'))
        } else {
          numero = parseFloat(valor)
        }

        numero = numero.toFixed(casas_decimais).split('.')
        numero[0] = numero[0].split(/(?=(?:...)*$)/).join('.')

        return sinal + numero.join(',')
      }
    },

    totalizarTipoPlanoFinanceiro(tipo_plano) {
      let retorno = {
        total_periodo_1: 0,
        total_periodo_2: 0,
        resultado: 0,
        percentual: 0
      }

      if (!this.afericao_lucro) {
        return retorno
      }

      if (this.configuracoes.planos_financeiros) {
        for (let i = 0; i < this.afericao_lucro.planos_financeiros.length; i++) {
          for (let j = 0; j < this.configuracoes.planos_financeiros.length; j++) {
            if (
              this.afericao_lucro.planos_financeiros[i].plano_financeiro_id !=
              this.configuracoes.planos_financeiros[j].plano_financeiro_id
            ) {
              continue
            }

            if (this.configuracoes.planos_financeiros[j].tipo_plano == tipo_plano) {
              retorno.total_periodo_1 += parseFloat(this.afericao_lucro.planos_financeiros[i].total_periodo_1)
              retorno.total_periodo_2 += parseFloat(this.afericao_lucro.planos_financeiros[i].total_periodo_2)
            }
          }
        }
      }

      let analise_vertical = this.calcularPercentualAnaliseVertical(
        retorno.total_periodo_1,
        retorno.total_periodo_2
      )

      retorno.resultado = analise_vertical.resultado
      retorno.percentual = analise_vertical.percentual

      if ((tipo_plano == 'ATI') || (tipo_plano == 'DLU')) {
        retorno.total_periodo_1 = 0
        retorno.resultado = retorno.total_periodo_2
        retorno.percentual = 100
      }

      return retorno
    },

    totalizarPassivoOperacional() {
      if (!this.afericao_lucro) {
        return null
      }

      let retorno = {
        total_periodo_1: 0,
        total_periodo_2: 0,
        resultado: 0,
        percentual: 0
      };

      for (let i = 0; i < this.afericao_lucro.financeiros_pagar.length; i++) {
        if (this.afericao_lucro.financeiros_pagar[i].selecionado != plano) {
          continue
        }

        retorno.total_periodo_1 += parseFloat(
          this.afericao_lucro.financeiros_pagar[i].total_periodo_1
        )

        retorno.total_periodo_2 += parseFloat(
          this.afericao_lucro.financeiros_pagar[i].total_periodo_2
        )
      }

      let analise_vertical = this.calcularPercentualAnaliseVertical(
        retorno.total_periodo_1,
        retorno.total_periodo_2
      )

      retorno.resultado = analise_vertical.resultado
      retorno.percentual = analise_vertical.percentual

      return retorno
    },

    totalizarContasPagar(plano) {
      if (!this.afericao_lucro) {
        return null;
      }

      let retorno = {
        total_periodo_1: 0,
        total_periodo_2: 0,
        resultado: 0,
        percentual: 0
      }

      for (let i = 0; i < this.afericao_lucro.financeiros_pagar.length; i++) {
        if (this.afericao_lucro.financeiros_pagar[i].selecionado != plano) {
          continue
        }

        retorno.total_periodo_1 += parseFloat(this.afericao_lucro.financeiros_pagar[i].total_periodo_1)
        retorno.total_periodo_2 += parseFloat(this.afericao_lucro.financeiros_pagar[i].total_periodo_2)
      }

      let analise_vertical = this.calcularPercentualAnaliseVertical(
        retorno.total_periodo_1,
        retorno.total_periodo_2
      )

      retorno.resultado = analise_vertical.resultado
      retorno.percentual = analise_vertical.percentual

      return retorno
    },

    totalizarContas(tipo_conta) {
      let retorno = {
        total_periodo_1: 0,
        total_periodo_2: 0,
        resultado: 0,
        percentual: 0
      }

      if (!this.afericao_lucro) {
        return retorno
      }

      for (let i = 0; i < this.afericao_lucro.contas.length; i++) {
        if (!this.afericao_lucro.contas[i].selecionada) {
          continue
        }

        if (this.afericao_lucro.contas[i].tipo_conta != tipo_conta) {
          continue
        }

        retorno.total_periodo_1 += parseFloat(this.afericao_lucro.contas[i].total_periodo_1)
        retorno.total_periodo_2 += parseFloat(this.afericao_lucro.contas[i].total_periodo_2)
      }

      let analise_vertical = this.calcularPercentualAnaliseVertical(
        retorno.total_periodo_1,
        retorno.total_periodo_2
      )

      retorno.resultado = analise_vertical.resultado
      retorno.percentual = analise_vertical.percentual

      return retorno
    },

    totalizarAtivo() {
      let total_ativo = {
        total_periodo_1: 0,
        total_periodo_2: 0,
        resultado: 0,
        percentual: 0
      }

      if (!this.afericao_lucro) {
        return total_ativo
      }

      let planos_ativo = this.totalizarTipoPlanoFinanceiro('ATI')
      let contas_caixa = this.totalizarContas('CAI')
      let contas_aplicacoes = this.totalizarContas('APL')

      total_ativo = {
        total_periodo_1:
          parseFloat(contas_caixa.total_periodo_1) +
          parseFloat(contas_aplicacoes.total_periodo_1) +
          parseFloat(this.afericao_lucro.totais_financeiros_receber.total_periodo_1) +
          parseFloat(this.afericao_lucro.totais_inventarios.total_periodo_1) +
          parseFloat(planos_ativo.total_periodo_1),

        total_periodo_2:
          parseFloat(contas_caixa.total_periodo_2) +
          parseFloat(contas_aplicacoes.total_periodo_2) +
          parseFloat(this.afericao_lucro.totais_financeiros_receber.total_periodo_2) +
          parseFloat(this.afericao_lucro.totais_inventarios.total_periodo_2) +
          parseFloat(planos_ativo.total_periodo_2)
      }

      let analise_vertical = this.calcularPercentualAnaliseVertical(
        total_ativo.total_periodo_1,
        total_ativo.total_periodo_2
      )

      total_ativo.resultado = analise_vertical.resultado
      total_ativo.percentual = analise_vertical.percentual

      return total_ativo
    },

    totalizarPassivo() {
      if (!this.afericao_lucro) {
        return null
      }

      let passivo_op = this.totalizarContasPagar('PAO')
      let passivo_inv = this.totalizarContasPagar('PAI')

      let balanco_passivo = {
        total_periodo_1:
          parseFloat(passivo_op.total_periodo_1) +
          parseFloat(passivo_inv.total_periodo_1),

        total_periodo_2:
          parseFloat(passivo_op.total_periodo_2) +
          parseFloat(passivo_inv.total_periodo_2)
      }

      let analise_vertical = this.calcularPercentualAnaliseVertical(
        balanco_passivo.total_periodo_1,
        balanco_passivo.total_periodo_2
      )

      balanco_passivo.resultado = analise_vertical.resultado
      balanco_passivo.percentual = analise_vertical.percentual

      return balanco_passivo
    },

    totalizarBalanco() {
      if (!this.afericao_lucro) {
        return undefined;
      }

      let total_ativo = this.totalizarAtivo();
      let total_passivo = this.totalizarPassivo();
      let total_distrib_lucro = this.totalizarTipoPlanoFinanceiro('DLU');

      let balanco = {
        total_periodo_1:
          total_ativo.total_periodo_1 +
          total_distrib_lucro.total_periodo_1 -
          total_passivo.total_periodo_1,

        total_periodo_2:
          total_ativo.total_periodo_2 +
          total_distrib_lucro.total_periodo_2 -
          total_passivo.total_periodo_2
      }

      let analise_vertical = this.calcularPercentualAnaliseVertical(
        balanco.total_periodo_1,
        balanco.total_periodo_2
      );

      balanco.resultado = analise_vertical.resultado;
      balanco.percentual = analise_vertical.percentual;

      return balanco;
    },

    async baixarPlanilhaResultado() {
      this.processando = true;

      try {
        let dados_afericao_lucro = JSON.parse(
          JSON.stringify(this.afericao_lucro)
        )

        dados_afericao_lucro.ativo_investimento = JSON.parse(
          JSON.stringify(this.getPlanosTipoAtivoInvestimento)
        );

        dados_afericao_lucro.distribuicao_lucro = JSON.parse(
          JSON.stringify(this.getPlanosTipoDistribuicaoLucro)
        );

        dados_afericao_lucro.prejuizos = JSON.parse(
          JSON.stringify(this.getMovimentosPrejuizo())
        );

        dados_afericao_lucro.contas = JSON.parse(
          JSON.stringify(this.getContasSelecionadas())
        );
        
        dados_afericao_lucro.totais_contas_caixas_bancos = this.totalizarContas('CAI');
        dados_afericao_lucro.totais_contas_aplicacoes = this.totalizarContas('APL');

        dados_afericao_lucro.periodo = (
          this.configuracoes.periodo.periodo_selecionado_1 +
          '  e  ' +
          this.configuracoes.periodo.periodo_selecionado_2
        )

        dados_afericao_lucro.periodo_exibicao_1 = this.periodo_exibicao_1
        dados_afericao_lucro.periodo_exibicao_2 = this.periodo_exibicao_2

        dados_afericao_lucro.empresas = []
        for (let i = 0; i < this.configuracoes.empresas.length; i++) {
          if (!this.configuracoes.empresas[i].selecionada) {
            continue;
          }

          dados_afericao_lucro.empresas.push({
            empresa_id: this.configuracoes.empresas[i].empresa_id,
            nome_resumido: this.configuracoes.empresas[i].nome_resumido
          })
        }

        dados_afericao_lucro.totais_ativo_investimento = this.totalizarTipoPlanoFinanceiro('ATI');
        dados_afericao_lucro.total_balanco_ativo = this.totalizarAtivo();
        dados_afericao_lucro.total_balanco_distrib_lucro = this.totalizarTipoPlanoFinanceiro('DLU');
        dados_afericao_lucro.totais_distribuicao_lucro = this.totalizarTipoPlanoFinanceiro('DLU');
        dados_afericao_lucro.totais_passivo_investimento = this.totalizarContasPagar('PAI');
        dados_afericao_lucro.totais_passivo_operacional = this.totalizarContasPagar('PAO');
        dados_afericao_lucro.total_balanco_passivo = this.totalizarPassivo();
        dados_afericao_lucro.resultado = this.totalizarBalanco();
        dados_afericao_lucro.totais_prejuizos = this.getTotaisPrejuizo;
        dados_afericao_lucro.totais_balanco = this.getTotaisBalancoResultado;
        dados_afericao_lucro.totais_final = this.getTotalFinal;

        let retorno = await RAfericaoLucro.gerarPlanilhaAfericaoLucro1(
          this.axios,
          dados_afericao_lucro
        );

        if (retorno.houve_erro != 'N') {
          throw new Error(retorno.mensagem);
        }
        
        window.open(
          process.env.API + '/afericao_lucro/' + retorno.dados.caminho_arquivo,
          '_blank'
        );

        this.processando = false;
      }
      catch(e) {
        toastr.error('Não foi possível gerar a planilha! ' + e.message);
        this.processando = false;
      }
    },

    getPlanosTipo: function(tipo) {
      let retorno = []

      if ((!this.afericao_lucro) || (!this.afericao_lucro.planos_financeiros)) {
        return retorno
      }

      for (let i = 0; i < this.afericao_lucro.planos_financeiros.length; i++) {
        if (this.afericao_lucro.planos_financeiros[i].tipo_plano != tipo) {
          continue
        }

        retorno.push(JSON.parse(JSON.stringify(this.afericao_lucro.planos_financeiros[i])))
      }

      if ((tipo == 'ATI') || (tipo == 'DLU')) {
        for (let i = 0; i < retorno.length; i++) {
          retorno[i].total_periodo_1 = 0
          retorno[i].resultado = retorno[i].total_periodo_2
          retorno[i].percentual = 100
        }
      }

      return retorno 
    },

    getMovimentosPrejuizo: function() {
      let prejuizos_mostrar = []

      if ((!this.afericao_lucro) || (!this.afericao_lucro.prejuizos)) {
        return prejuizos_mostrar
      }

      if (this.configuracoes.mostrar_titulos_definidos_prejuizo) {

        for (let i = 0; i < this.afericao_lucro.prejuizos.length; i++) {
        
          if (this.afericao_lucro.prejuizos[i].tipo == 'CDE') {
            prejuizos_mostrar.push(
              {
                tipo: 'CDE',
                descricao: 'Cheques devolvidos',
                total_periodo_1: 0,
                total_periodo_2: this.afericao_lucro.prejuizos[i].total_periodo_2,
                resultado: this.afericao_lucro.prejuizos[i].total_periodo_2,
                percentual: 100
              }
            )
          }

        }
      }


      if (this.configuracoes.mostrar_perca_estoque) { 
        for (let i = 0; i < this.afericao_lucro.prejuizos.length; i++) {
          if (this.afericao_lucro.prejuizos[i].tipo == 'PES') {
            prejuizos_mostrar.push(
              {
                tipo: 'PES',
                descricao: 'Perdas de estoque',
                total_periodo_1: 0,
                total_periodo_2: this.afericao_lucro.prejuizos[i].total_periodo_2,
                resultado: this.afericao_lucro.prejuizos[i].total_periodo_2,
                percentual: 100
              }
            )
          }

        }
      }

      return prejuizos_mostrar
    },

    getContasSelecionadas() {
      let contas_selecionadas = []

      if ((!this.afericao_lucro) || (!this.afericao_lucro.contas)) {
        return contas_selecionadas
      }

      for (let i = 0; i < this.afericao_lucro.contas.length; i++) {      
        if (!this.afericao_lucro.contas[i].selecionada) {
          continue
        }

        contas_selecionadas.push(JSON.parse(JSON.stringify(this.afericao_lucro.contas[i])))
      }

      return contas_selecionadas
    },

    getContasTipoSelecionado(tipo_conta) {
      let contas_tipo = []
      let contas_selecionadas = this.getContasSelecionadas()
      for (let i = 0; i < contas_selecionadas.length; i++) {      
        if (contas_selecionadas[i].tipo_conta != tipo_conta) {
          continue
        }

        contas_tipo.push(JSON.parse(JSON.stringify(contas_selecionadas[i])))
      }

      return contas_tipo
    }
  },

  computed: {
    getTotaisPlanosAtivoInvestimento: function() {
      return this.totalizarTipoPlanoFinanceiro('ATI')
    },

    getPlanosTipoAtivoInvestimento: function() {
      return this.getPlanosTipo('ATI')
    },

    getContasAplicacaoSelecionadas: function() {
      return this.getContasTipoSelecionado('APL')
    },

    getPlanosTipoDistribuicaoLucro: function() {
      return this.getPlanosTipo('DLU')
    },

    getTotaisPassivoOperacional: function() {
      return this.totalizarContasPagar('PAO');
    },

    getTotaisPlanosPassivoInvestimento: function() {
      return this.totalizarContasPagar('PAI')
    },

    getTotaisBalancoAtivo: function() {
      return this.totalizarAtivo()
    },

    getTotaisContasCaixasBancos: function() {
      return this.totalizarContas('CAI')
    },

    getTotaisContasAplicacoes: function() {
      return this.totalizarContas('APL')
    },

    getTotaisBalancoPassivo: function() {
      return this.totalizarPassivo()
    },

    getTotaisBalancoDistribuicaoLucro: function() {
      return this.totalizarTipoPlanoFinanceiro('DLU')
    },

    getTotaisBalancoResultado: function() {
      return this.totalizarBalanco()
    },

    getTodasContas: function() {
      if ((!this.afericao_lucro) || (!this.afericao_lucro.contas)) {
        return []
      }
      
      this.afericao_lucro.contas = JSON.parse(JSON.stringify(this.afericao_lucro.contas))
      return this.afericao_lucro.contas
    },

    getTotaisPrejuizo: function() {
      let movimentos_prejuizo = this.getMovimentosPrejuizo()

      let obj = {
        total_periodo_1: 0,
        total_periodo_2: 0,
        resultado: 0,
        percentual: 0
      }

      for (let i = 0; i < movimentos_prejuizo.length; i++) {
        obj.total_periodo_1 += parseFloat(movimentos_prejuizo[i].total_periodo_1)
        obj.total_periodo_2 += parseFloat(movimentos_prejuizo[i].total_periodo_2)
      }

      let analise_vertical = this.calcularPercentualAnaliseVertical(
        obj.total_periodo_1,
        obj.total_periodo_2
      )

      obj.resultado = analise_vertical.resultado
      obj.percentual = analise_vertical.percentual

      return obj
    },

    getTotalFinal: function() {
      let obj = {
        total_periodo_1: this.totalizarBalanco().total_periodo_1 - this.getTotaisPrejuizo.total_periodo_1,
        total_periodo_2: this.totalizarBalanco().total_periodo_2 - this.getTotaisPrejuizo.total_periodo_2,
        resultado: 0,
        percentual: 0
      }

      let analise = this.calcularPercentualAnaliseVertical(obj.total_periodo_1, obj.total_periodo_2)

      obj.resultado = analise.resultado
      obj.percentual = analise.percentual

      return obj
    }
  },

  
  created() {
    this.buscarTodasEmpresas()
    this.buscarConfiguracoesAfericaoLucro()
  }
}
</script>

<style scoped>
.link {
  cursor: pointer !important;
  font-weight: bold;
}

.checkbox-group strong {
  cursor: pointer;
}

.switch-input {
  display: none;
}

.switch-label {
  position: relative;
  display: inline-block;
  min-width: 112px;
  cursor: pointer;
  text-align: left;
  padding: 10px 0 10px 44px;
}

.switch-label:before,
.switch-label:after {
  content: "";
  position: absolute;
  margin: 0;
  outline: 0;
  top: 50%;
  -ms-transform: translate(0, -50%);
  -webkit-transform: translate(0, -50%);
  transform: translate(0, -50%);
  -webkit-transition: all 0.3s ease;
  transition: all 0.3s ease;
}

.switch-label:before {
  left: 1px;
  width: 34px;
  height: 14px;
  background-color: #9e9e9e;
  border-radius: 8px;
}

.switch-label:after {
  left: 0;
  width: 20px;
  height: 20px;
  background-color: #fafafa;
  border-radius: 50%;
  box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.14),
    0 2px 2px 0 rgba(0, 0, 0, 0.098), 0 1px 5px 0 rgba(0, 0, 0, 0.084);
}

.switch-label .toggle--on {
  display: none;
}

.switch-label .toggle--off {
  display: inline-block;
}

.switch-input:checked + .switch-label:before {
  background-color: #34acfe;
}

.switch-input:checked + .switch-label:after {
  background-color: #0080d6;
  -ms-transform: translate(80%, -50%);
  -webkit-transform: translate(80%, -50%);
  transform: translate(80%, -50%);
}

.lista-leitura-simples {
  display: inline-block;
  margin: 0;
  padding: 0;
  list-style: none;
}

.lista-leitura-simples li {
  display: inline-block;
  margin: 2px;
  padding: 2px 6px 2px 6px;
}

.lista-leitura {
  margin: 0;
  padding: 0;
  list-style: none;
}

.lista-leitura li {
  display: inline-block;
  border: 1px solid #888888;
  border-radius: 5px;
  margin: 2px;
  padding: 2px 6px 2px 6px;
  font-weight: 500;
  border-left: 7px solid #af1a1a;
  box-shadow: 0px 0px 7px #00000050;
}

.tabela-resultado {
  border: 1px solid #999999;
  border-collapse: collapse;
  width: 100%;
  text-align: right;
}

.cor-enfase {
  background-color: #90ee90;
}

.cor-enfase-2 {
  background-color: #e0ffff;
}

.cor-enfase-final {
  background-color: #044f81;
  color: #ffffff;
}

.cor-verde {
  color: #31b404;
}

.cor-vermelha {
  color: #af1a1a;
}

.link-vermelho {
  color: #af1a1a;
  text-decoration: underline;
  cursor: pointer;
}

.sublinhado {
  text-decoration: underline;
}

.borda-pontilhada-base {
  border-bottom: 1px dotted #666666;
}

.borda-pontilhada-topo {
  border-top: 1px dotted #666666;
}

.cor-enfase th {
  padding: 8px;
}

.linha-enfase {
  background-color: #dddddd;
}

.linha-enfase-principal {
  background-color: #000000;
}

.linha-enfase-principal strong {
  color: #ffffff;
}
</style>


// WEBPACK FOOTER //
// src/components/AfericaoLucro.vue